export default {
  hsk_left_time: 'Thời gian thi còn lại',
  hsk_submit_paper: 'Nộp bài thi',
  hsk_rotate_device_title: 'Vui lòng xoay thiết bị sang ngang',
  hsk_rotate_device_desc: 'Để có trải nghiệm thi tốt nhất',
  hsk_not_finished: 'Chưa hoàn thành',
  hsk_not_start: 'Chưa bắt đầu',
  hsk_finished: 'Đã hoàn thành',
  hsk_if_test: 'Lần thi trước của Bạn vẫn chưa có kết quả, Bạn có tiếp tục thi không?',
  hsk_progress_lost_restart: 'Không tìm thấy câu trả lời trước đó của bạn. Bài thi này sẽ bắt đầu từ câu hỏi đầu tiên.',
  hsk_exam_data_error: 'Dữ liệu bài thi gặp lỗi. Vui lòng quay lại và thử lại.',
  hsk_start_again: 'Thi lại',
  hsk_go_on: 'Tiếp tục thi',
  hsk_if_save:
    'Có xác định thoát khỏi kỳ thi mô phỏng không? \nSau khi thoát khỏi u đáp áp câu hỏi sẽ được bảo lưu, lần sau đăng nhập có thể tiếp tục trả lời bộ câu hỏi này.',
  hsk_login_filed:
    'Thông tin đăng nhập của bạn đã hết hạn, chúng tôi sẽ giữ không lưu giữ hồ sơ trả lời của bạn.',
  hsk_report: 'Bảng câu trả lời',
  hsk_point: 'Điểm',
  hsk_qualified_point: 'Điểm đạt',
  hsk_part1: 'Các phần {part}',
  hsk_accuracy1: 'Tỷ lệ chính xác',
  hsk_test_again: 'Thi lại lần nữa',
  hsk_example: 'Ví dụ',
  hsk_example_eg: 'Ví dụ',
  hsk_answer_analysis: 'Phân tích đáp án',
  hsk_your_answer: 'Đáp án của bạn',
  hsk_audio_text: 'Nghe đoạn văn',
  hsk_correct_answer: 'Đáp án đúng',
  hsk_listen_name: 'Phần nghe',
  hskk_listen_name: 'Kiểm tra loa và micro',
  hsk_read_name: 'Đọc hiểu',
  hsk_write_name: 'Viết',
  hsk_reference_answer: 'Đáp án tham khảo',
  hsk_question_audio_content: 'Nội dung âm thanh đề thi:',
  hsk_reference_answer_hskk: 'Nội dung âm thanh câu hỏi',
  hsk_submit_msg: 'Bạn có chắc là nộp bài thi?',
  hsk_homework_no_answer: 'Chưa có câu trả lời',
  hsk_practice_sava:
    'Bạn xác nhận là rời khỏi việc luyện tập không, Bạn xác nhận rời khỏi việc luyện tập không? đáp án sẽ không được bảo lưu sau khi thoát ',
  hsk_practice_go: 'Luyện tập',
  hsk_practice_part: 'Đề luyện tập',
  hsk_practice_operate: 'Thao tác',
  hsk_practice_check: 'Xem',
  hsk_practice_num1: 'Trả lời đúng',
  hsk_practice_num2: 'Tổng số câu hỏi',
  hsk_preview_listen_msg:
    'Bây giờ sẽ phát hướng dẫn về bài thi, trong thời gian này có thể xem qua câu hỏi bằng cách nhấp vào số câu hỏi trong thẻ đáp án',
  hsk_preview_listen_prompt:
    'Bây giờ sẽ phát hướng dẫn về bài thi, trong thời gian này có thể xem qua câu hỏi bằng cách nhấp vào số câu hỏi trong thẻ đáp án.Vui lòng không làm mới hoặc đóng trang trong quá trình làm bài thi, nếu không dữ liệu câu trả lời sẽ bị mất.',
  hsk_enter_next_segment_msg: 'Bạn xác định bước vào phần thi tiếp theo?',
  hsk_enter_next_segment_preview:
    'Kết thúc phần xem trước ngay bây giờ? Khi thời gian xem trước kết thúc, phần thi nghe của bạn sẽ bắt đầu.',
  hsk_enter_next_segment_listen_tip: 'Bạn có {count} câu nghe chưa điền đáp án',
  hsk_enter_next_segment_listen: 'Bạn muốn nộp phần thi nghe? Sau khi nộp, bài nghe kết thúc',
  hsk_enter_next_segment_listen_review_start:
    'Bây giờ là phần thi nghe. Bạn sẽ có {count} phút để kiểm tra câu trả lời của mình cho các câu hỏi phần nghe.',
  hsk_enter_next_segment_listen_review:
    'Bạn chắc chắn muốn kết thúc phần thi nghe? Sau khi kết thúc phần thi nghe, phần thi đọc sẽ bắt đầu.',
  hsk_enter_next_segment_read_tip: 'Bạn có {count} câu đọc chưa diền đáp án',
  hsk_enter_next_segment_read:
    'Bạn có chắc chắn muốn nộp câu trả lời cho phần thi đọc không? Sau khi nộp, phần thi đọc sẽ kết thúc và bạn sẽ không thể quay lại để sửa.',
  hsk_enter_next_segment_write_tip: 'Bạn có {count} câu viết chưa điền đáp án',
  hsk_enter_next_segment_write: 'Bạn xác nhận nộp bài thi?',
  hsk_end_preview: 'Kết thúc việc xem trước',
  hsk_submit_listen: 'Nộp bài thi nghe',
  hsk_end_review: 'Kết thúc việc soát lại/rà lại',
  hsk_start_exam: 'Bắt đầu thi',
  hsk_link_test: 'Thi thử trên đề thật',
  hsk_link_tips: 'Thi thử trên đề thật và nhận giấy chứng nhận chính thức',
  hsk_buy: 'Mua',
  hsk_test_ready: 'Chuẩn bị trước khi thi',
  hsk_test_ready_tips:
    'Đề thi này bao gồm phần kỹ năng nghe, đề nghị điều chỉnh thiết bị phát âm thanh, phần thi kỹ năng nghe chuẩn bị bắt đầu',
  hsk_test_content: 'Nội dung thi',
  hsk_test_num: 'Số lượng câu hỏi',
  hsk_total_num: 'Tổng số  câu hỏi',
  hsk_test_time: 'Thời gian thi',
  hsk_time_total: 'Tổng thời gian',
  hsk_test_minute: 'Phút',
  hsk_about: 'Khoảng',
  hsk_abbreviation: 'Tôi muốn viết tóm tắt',
  hsk_determine_ans: 'Xác định bắt đầu trả lời hay chưa?',
  hsk_determine_ans_tips: 'Sau khi bắt đầu viết đáp án, thì không thể xem lại đoạn văn trước đó',
  no_data: 'Tạm thời không có dữ liệu',
  hsk_question_number: 'Số lượng đề',
  hsk_test_rate: 'Chiếm tỷ lệ thi',
  hsk_right_rate: 'Độ chính xác',
  hsk_operation: 'Thao tác',
  hsk_skip: 'Bỏ qua',
  hsk_spend: 'Chi phí',
  hsk_cost: 'Chi phí',
  hsk_credit: 'Số dư',
  hsk_pay_successfully: 'Thanh toán thành công',
  hsk_select_amount: 'Chọn số tiền nạp vào',
  button_common_ok: 'Xác định',
  button_common_cancel: 'Huỷ',
  change_lang_ok: 'Xác nhận',
  change_lang_cancel: 'Huỷ',
  hint_player_loader_error: 'Không thể phát đoạn hội thoại',
  hint_common_wait_loading: 'Đang trong quá trình tải xuống',
  button_common_hand_in: 'Nộp/giao',
  test_total_question: 'Tổng đề(câu hỏi)',
  test_release: 'Tuyên bố/phát',
  test_off_shelf: 'Khung dưới',
  test_enable: 'Bắt đầu đăng ký',
  test_record: 'Lịch sử thi mô phỏng',
  test_finish_time: 'Thời gian hoàn thành',
  test_paper: 'Bài thi',
  test_confirm_use: 'Xác nhận đăng ký',
  test_confirm_off_shelf: 'Xác nhận sang trang sau',
  test_has_on_shelf: 'Đã sang trang trước(đã về trang trước)',
  test_un_release: 'Chưa tuyên bố/phát',
  test_un_enable: 'Chưa đăng ký',
  test_max_score: 'Điểm cao nhất',
  test_average_score: 'Điểm bình quân',
  test_min_score: 'Điểm thấp nhất',
  test_all: 'Toàn bộ',
  test_has_practiced: 'Đã luyện tập, mời xem kết quả',
  test_paper_office: 'Bài thi đã sang trang sau!',
  test_complete_introduce: 'Hoàn thành giới thiệu',
  test_course_link: 'Khoá học chính thức',
  test_about_down_load: 'Tải nội dung liên quan',
  test_pay: 'Chi trả',
  mark_answer_user: 'Người trả lời',
  mark_answer_time: 'Thời gian trả lời',
  mark_correct_time: 'Thời gian sửa bài',
  mark_correct_status: 'Trạng thái sửa bài',
  mark_correct_user: 'Người sửa',
  mark_correct_option: 'Thao tác',
  mark_correct_ing: 'Trong quá trình sửa bài',
  mark_un_correct: 'Chưa sửa',
  mark_has_correct: 'Đã sửa',
  mark_report_tips:
    'Chú ý: Phần thi viết tạm thời chưa nhập vào tổng điểm, đề sẽ được chấm sửa trong vòng 48 tiếng bởi người có trách nhiệm chuyên môn, sau đó tổng điểm sẽ cập nhật đồng bộ, đến lúc đó chúng tôi sẽ thông báo cho bạn qua Email.',
  mark_report_tips_hskk:
    'Chú ý: đề sẽ được chấm sửa trong vòng 48 tiếng bởi người có trách nhiệm chuyên môn, sau đó tổng điểm sẽ cập nhật đồng bộ, đến lúc đó chúng tôi sẽ thông báo cho bạn qua Email.',
  mark_submit_btn: 'Nộp bản sửa',
  mark_submit_tips: 'Bạn đã chắc chắn nộp bản sửa?',
  mark_back: 'Phản hồi',
    hsk_answer_sheet: 'Phiếu trả lời',
  mark_correct_tips: 'Hiện nay bài thi đang trong quá trình sửa, không thể sửa lại!',
  mark_correct_person: 'Bộ phận chuyên môn sửa',
  search_user_message: 'Tìm tên người dùng',
  mark_current_user: 'Người dùng hiện tại',
  mark_correct_paper: 'Sửa',
  mark_all_status: 'Toàn bộ trạng thái',
  mark_all_level: 'Toàn bộ cấp bậc thi',
  mark_overtime: 'Vượt quá thời gian',
  mark_answer: 'Trả lời',
  mark_ai_suggest_score: 'AI suggested score',
  home_test_registration: 'Báo danh thi/đăng ký thi',
  home_word_outline: 'Đại cương từ vựng',
  home_online_practice: 'Mẫu đề thi mô phỏng',
  home_test: 'Thi mô phỏng',
  home_page: 'Trang đầu',
  common_text_control_speed: 'Tốc độ phát',
  button_common_playback: 'Phát đoạn ghi âm',
  common_text_file_error: 'Tải dữ liệu thất bại, đề nghị thử lại',
  common_text_server_error: 'Thử lại 1 lần nữa',
  common_text_none_network: 'Mạng không ổn định',
  button_common_start_over: 'Thi thử lại',
  evaluating_tips_common:
    'Nội dung ghi âm đọc và nội dung văn bản khác biệt tương đối lớn, mời ghi âm lại.',
  evaluate_common_total_score: 'Đạt điểm',
  evaluate_common_training_remain: 'Còn lại',
  evaluate_common_training_readyRcord: 'Chuẩn bị ghi âm',
  evaluate_common_training_atleast: 'Thời gian ghi âm phải dài hơn 1 giây',
  evaluate_common_training_atleast2: 'Thời gian ghi âm phải dài hơn 2 giây',
  evaluate_common_training_evaluting: 'Trong quá trình chấm điểm',
  evaluating_tips_additionalAndBack:
    'Quá trình đọc  xuất hiện tình trạng đọc thừa/học lặp ( đọc lặp/đọc lại )sẽ ảnh hưởng đến tổng điểm',
  textbook_chioce_word_text_correct_tip: 'Trả lời chính xác, rất xuất sắc!',
  textbook_chioce_word_text_error_tip: 'Bạn đã trả lời sai, cần cố gắng hơn!',
  textbook_reading_comprehension_stem: 'Giải thích đọc hiểu',
  spc_back_tips:
    'Bạn xác nhận là rời khỏi việc luyện tập không, nếu bạn rời khỏi thì đáp án đã làm sẽ không được bảo lưu.',
  spc_level_text: 'Kiểm tra trình độ',
  spc_capability_assessment: 'Đánh giá năng lực',
  spc_pick_level: 'Chọn cấp độ',
  spc_listen: 'Nghe',
  spc_speak: 'Nói',
  spc_read: 'Đọc',
  spc_write: 'Viết',
  spc_translation: 'Dịch',
  spc_result_tips: 'Qua kiểm tra, năng lực tiếng trung của Bạn đã tương đương với trình độ…',
  spc_recommend_test: 'Đề nghị bạn chuẩn bị thi trình độ Hán ngữ (HSK) cấp độ…',
  spc_recommend_test1: '推荐备考<strong> HSK {level}</strong> 级',
  spc_again_test: 'Kiểm tra lại',
  spc_where_tips: 'Không xác định trình độ tiếng Trung của tôi?',
  spc_immediate_test: 'Lập tức kiểm tra',
  spc_test_content: 'Nội dung kiểm tra',
  spc_test_content_desc:
    'Năng lực của người học sẽ được kiểm tra trên 5 khía cạnh: nghe, nói, đọc (đọc thành tiếng), viết (đánh máy hoặc lựa chọn) và dịch. Các cấp độ khác nhau có các câu hỏi kiểm tra khác nhau.',
  spc_test_timer: 'Thời gian kiểm tra',
  spc_test_timer_desc:
    'Bài kiểm tra kéo dài khoảng 15 phút, cấp độ càng cao thì thời gian càng dài.',
  spc_test_result: 'Kiểm tra kết thúc',
  spc_test_result_desc:
    'Bài kiểm ra giúp bạn nhanh chóng xác định trình độ HSK bạn đang hướng tới, và nâng cao các kỹ năng bản thân còn hạn chế.',
  vocab_level_word: 'Từ vựng cấp…',
  vocab_total_item: 'Tổng',
  vocab_search: 'Tìm kiếm chữ hán/phiên âm/phiên dịch',
  vocab_all_marked: 'Tất cả ký hiệu/đánh dấu',
  vocab_already_marked: 'Đã đánh dấu',
  vocab_unmarked: 'Chưa đánh dấu',
  vocabulary: 'Từ ngữ',
  vocab_pinyin: 'Phiên âm',
  vocab_translate: 'Phiên dịch',
  vocab_mark: 'Đánh dấu',
  delete_confirmation: 'Xác nhận xoá từ vựng',
  cancel: 'Huỷ',
  del: 'Xoá',
  edit_vocab: 'Biên tập từ vựng',
  save: 'Lưu',
  add_vocab: 'Thêm từ mới',
  hanzi: 'Chữ hán',
  num_bihua: 'Số nét bút',
  write_demo: 'Hướng dẫn viết',
  vocab_side: 'Viết bộ thủ',
  level: 'Cấp độ hiện tại',
  see_more: 'Xem nhiều hơn',
  same_read_word: 'Từ đồng âm',
  samilar_read_word: 'Từ cận âm',
  add_mark: 'Thêm ký hiệu',
  word_team: 'Tổ từ',
  instance: 'Câu ví dụ',
  include_num_char: 'Bao gồm tổng bao nhiêu chữ hán',
  length_diff: 'Phiên âm và độ dài chữ hán không đồng nhất với nhau',
  add_word_success: 'Thêm từ vựng thành công',
  add_word_fail: 'Thêm từ vựng thất bại',
  edit_word_success: 'Biên tập từ vựng thành công',
  edit_word_fail: 'Biên tập từ vựng thất bại',
  del_success: 'Xoá thành công',
  del_fail: 'Xoá thất bại',
  mark_free: 'Có thể tự do đánh dấu, ví dụ đánh dấu là "Đã nắm vững"',
  write_word_sentence: 'Căn cứ vào các từ ở trên để đặt câu…',
  write_word_artical: 'Căn cứ vào các từ khoá ở trên để viết đoạn văn ngắn…',
  write_img_artical: 'Căn cứ vào hình vẽ phía trên để viết đoạn văn ngắn…',
  write_artical_title: 'Đề nghị nhập tiêu đề vào bài văn…',
  write_artical_content: 'Đề nghị nhập nội dung chính văn…',
  my_wallet: 'Ví tiền của tôi',
  learn_history: 'Học bạ/ghi chép học tập',
  manage: 'Quản lý',
  birthday: 'Sinh nhật',
  email: 'Hòm thư điện tử',
  change_pw: 'Thay đổi mật khẩu',
  edit_info: 'Biên soạn thông tin',
  lastName: 'Họ',
  firstName: 'Tên',
  gender: 'Giới tính',
  female: 'Nữ',
  male: 'Nam',
  non_disclosure: 'Không tiết lộ',
  change_avatar: 'Thay đổi ảnh đại diện/ảnh chân dung',
  preview_avatar: 'Xem trước ảnh đại diện',
  upload_image: 'Tải hình ảnh lên',
  change_image: 'Thay đổi hình ảnh',
  enter_old_pw: 'Nhập mật khẩu cũ',
  enter_new_pw: 'Nhập mật khẩu mới',
  enter_new_pw_again: 'Nhập lại mật khẩu mới',
  forget_pw: 'Quên mật khẩu',
  recharge: 'Nạp thêm tiền',
  left_balance: 'Số dư khả dụng',
  consume_log: 'Thống kê/lịch sử chi phí',
  recharge_log: 'Lịch sử nộp tiền',
  consume_time: 'Thời gian tiêu hao',
  consume_source: 'Tài nguyên tiêu hao',
  consume_money: 'Mức tiền tiêu hao',
  total_item_log: 'Tổng … ghi chép',
  recharge_time: 'Thời gian nộp thêm tiền',
  recharge_num: 'Số lượng nộp vào',
  recharge_money: 'Số tiền nộp vào',
  recharge_method: 'Phương thức chi trả/thanh toán',
  learn_content: 'Nội dung học tập',
  total_score: 'Tổng điểm',
  view_result: 'Xem thành tích',
  management: 'Quản lý',
  give_history: 'Lịch sử tặng biếu',
  total_recharge: 'Tổng cộng chi phí nộp vào',
  last_login: 'Đăng nhập gần nhất',
  give: 'Tặng biếu',
  gifted: 'Tặng biếu',
  give_time: 'Thời gian tặng biếu',
  give_to_person: 'Người trao tặng',
  opera_person: 'Người thao tác',
  give_to: 'Tặng cho',
  old_password_empty: 'Mật khẩu cũ không được để trống',
  diff_password: 'Hai lần nhập mật khẩu không giống nhau',
  change_pw_success: 'Thay đổi mật khẩu thành công',
  change_pw_fail: 'Thai đổi mật khẩu thất bại',
  change_info_success: 'Thay đổi thông tin thành công',
  change_info_fail: 'Thay đổi thông tin thất bại',
  statistics_center: 'Trung tâm thống kê',
  select_recharge_mount: 'Lựa chọn số tiền bổ sung/điều chỉnh',
  waiting_pay: 'Trong quá trình đợi thanh toán/chi trả',
  has_no_resolve_credit: 'Chưa nhận được thanh toán, xin vui lòng thử lại.',
  complete_pay: 'Đã hoàn thành thanh toán/chi trả',
  pay_fail: 'Thanh toán/chi trả thất bại',
  give_success: 'Tặng cho thành công',
  give_fail: 'Tặng cho  thất bại',
  change_avatar_success: 'Thay đổi ảnh đại diện/ảnh chân dung thành công',
  change_avatar_fail: 'Thay đổi ảnh đại diện/ảnh chân dung thất bại',
  enter_family_name: 'Nhập họ',
  enter_given_name: 'Nhập tên',
  log_in: 'Đăng nhập ',
  log_in_error: 'Đăng nhập thất bại',
  email_address: 'Địa chỉ email',
  invalid_email_address: 'Địa chỉ hộp thư điện tử phi pháp',
  password: 'Mật khẩu',
  password_tip: 'Độ dài mật khẩu từ 6-20 ký tự/số',
  invalid_password: 'Định dạng mật khẩu không hợp lệ',
  have_account: 'Đã có số tài khoản',
  sign_up: 'Đăng ký',
  sign_up_error: 'Đăng ký thất bại',
  forget_pw_success: 'Thiết lập lại hộp thư mật mã gửi đi thành công',
  forget_pw_error: 'Thiết lập lại hộp thư mật mã gửi đi thất bại',
  loading: 'Trong quá trình tải',
  account_block: 'Số tài khoản bị cấm sử dụng',
  account_block_tip: 'Xin liên hệ với nhân viên quản lý của trường bạn để có thêm nhiều thông tin',
  resend_email: 'Gửi lại thư',
  resend_email_success: 'Thư đã được gửi lại',
  resend_email_error: 'Thư gửi lại bị thất bại',
  i_am: 'Tôi là',
  choose_role: 'Cái nào mô tả đúng nhất về bạn',
  choose_role_error: 'Chọn nhân vật thất bại',
  continue: 'Tiếp tục',
  learner: 'Học sinh',
  learner_description: 'Tôi đang học tiếng Trung',
  teacher: 'Giáo viên',
  teacher_description: 'Tôi đang dạy tiếng Trung',
  setup_account_error: 'Thiết lập thông tin tài khoản thất bại',
  tos_link: 'Điều khoản dịch vụ',
  privacy_link: 'Chính sách bảo mật',
  email_verified: 'Hộp thư đã được xác thực',
  email_verified_tip: 'Cảm ơn đã xác thực hộp thư của bạn',
  email_verified_error: 'Không thể xác thực tài khoản của bạn',
  something_wrong: 'Phát sinh vấn đề rồi',
  retry: 'Thi thử lại',
  guardian_consent_error: 'Thao tác thất bại',
  about_us: 'Giới thiệu về chúng tôi',
  feedback: 'Liên hệ',
  download: 'Tải xuống',
  submit: 'Nộp/giao',
  feedback_success: 'Nộp/đưa thành công',
  feedback_error: 'Nộp/đưa thất bại',
  feedback_contact_tip: 'Sau khi gửi, chúng tôi sẽ liên hệ với bạn kịp thời qua email mà bạn đã dùng để đăng ký.',
  logout: 'Đăng xuất',
  my_account: 'Tài khoản của tôi',
  login_signup: 'Đăng nhập / đăng ký',
  please_enter_content: 'Nhập nội dung phản hồi (bắt buộc điền)',
  describe_detail:
    'Nếu bạn cho rằng là có vấn đề thì đề nghị cung cấp thông tin càng cụ thể càng tốt',
  upload_picture:
    'Khi tải hình ảnh lên (có thể chọn nhiều ảnh nhất {maxFiles}. Hỗ trợ đuôi ảnh JPG/PNG, dung lượng mỗi tấm ảnh không được vượt quá 2M)',
  file_error: 'Định dạng hoặc kích thước văn bản sai sót',
  file_num_limit: 'Số lượng tệp văn bản tải lên nhiều nhất là …cái',
  sure_change_lang: 'Thay đổi ngôn ngữ?',
  privacy_policy_text1:
    'HSK Mock.com là Diễn đàn thi mô  phỏng duy nhất được Tổ chức thi Hán ngữ quốc tế thừa nhận cấp phép.',
  privacy_policy_text2:
    'Diễn đàn thi mô phỏng do Wo Hui  và Tổ chức thi Hán ngữ quốc tế hợp tác khai thác và vận hành từ kho đề thi  YCT và HSK. Cung cấp các đề ôn luyện thi một cách chân thực, hoàn chỉnh; giúp  cho người học tiếng Trung tiêu chuẩn hoá, hỗ trợ đồng hành cùng người học để  tham gia kỳ thi tiếng Trung.',
  privacy_policy_text3:
    'Wo Hui Mandarin là đối tác mang  danh Nhà nước chính thức của Tổ chức thi Hán ngữ Quốc tế',
  privacy_policy_text4:
    'Công ty TNHH Khoa học Kỹ thuật  Hán ngữ quốc tế (Bắc Kinh) là cơ quan chuyên nghiệp hoá dịch vụ giảng dạy và  thi Hán ngữ quốc tế, cơ quan này đã giúp cho chuyên nghiệp hoá dịch vụ đối  với hoạt động mở rộng thị trường, tổ chức thi, nghiên cứu khai thác kỹ thuật,  nghiên cứu thiết kế bài giảng và kỳ thi tiếng Trung quốc tế của các quốc gia  (khu vực) trên thế giới; ở mức độ cao nhất thì cơ quan này đã đáp ứng đầy đủ  nhu cầu của người học tiếng Trung và cơ quan/tổ chức giảng dạy tiếng Trung  trên toàn cầu.',
  privacy_policy_text5:
    '"Tôi biết tiếng Trung"  là do Tập đoàn giáo dục quốc tế EiM sáng lập vào năm 2018 tại Singapore. Đây  là công ty độc lập có vai trò hỗ trợ kỹ thuật, là diễn đàn dịch vụ cho người  học tiếng Trung trên toàn thế giới. Cung cấp các giáo trình học khác nhau cho  từng đối tượng học viên khác nhau, ngoài ra cũng cung cấp cho giới giảng dạy  một nguồn tư liệu phong phú và là một công cụ giảng dạy thực dụng. Khoa học  kỹ thuật thông minh hỗ trợ việc dạy học, giải phóng cho đôi tay của thầy cô  giáo, hoàn thiện quá trình giảng dạy, giúp cho học sinh thực hiện được mục  tiêu của bản thân, khuyến khích học sinh trở thành người học độc lập xuất  sắc.',
  privacy_policy_text6:
    'Tổ chức thi Hán ngữ quốc tế và  Công ty "Tôi biết tiếng Trung" có quan hệ hợp tác nền tảng tốt đẹp,  mục đích chung là hỗ trợ cho việc phát triển và mở rộng hoạt động học tập  tiếng Trung. Nhằm đánh giá chính xác nhất năng lực của học sinh, việc hợp tác  chiến lược của hai đơn vị cũng là nhằm nâng cao môi trường học và thi chân  thực nhất cho học sinh, ngoài ra mục tiêu cao nhất là nhằm đáp ứng đầy đủ nhu  cầu học tập của người học tiếng Trung.',
  level_test: 'Kiểm tra trình độ',
  level_test_example:
    'Nếu bạn chưa xác định được trình độ của mình, có thể tham gia miễn phí lần khảo sát nhanh này để xem bạn thích hợp với mục tiêu học tập cho trình độ nào.',
  download_app_mobile:
    'Để có trải nghiệm tốt hơn khi sử dụng HSK Mock, xin vui lòng truy cập hskmock.com trên máy tính hoặc tải ứng dụng trên di dộng.',
  common_video_failed: 'Đoạn ghi âm tải xuống bị thất bại',
  member_error: 'Tư liệu bất thường!',
  agree_policy:
    'Tôi đã đọc và đồng ý với <u class="strong"><a href="{url}" target="_blank"> Điều khoản dịch vụ</a></u> và <u class="strong"><a href="{url}" target="_blank">Chính sách bảo mật</a></u>',
  please_check: 'Mời đọc và đồng ý với <<Thoả thuận người dùng>> và <<Chính sách bảo mật>>',
  media_devices_unsupported_browserLabel:
    'Vào trình duyệt cài đặt Google Chrome để chấp nhận trình duyệt. Cách cài đặt: Ví dụ là hệ điều hành Windows 10: Cài đặt>ứng dụng>chấp nhận ứng dụng > trình duyệt mạng>chọn Google Chrome',
  media_devices_help_title: 'Có mở micrô hay hông',
  media_devices_help_content: 'Bạn cần bật micrô để ghi âm thanh',
  batch_exist_user: 'Đã đăng ký tài khoản người dùng',
  batch_and: 'Và',
  batch_un_exist_user: 'Chưa đăng ký tài khoản người dùng',
  batch_from: 'Đến từ',
  batch_notes: 'Ghi chú',
  batch_something: 'Mời điền vào',
  batch_people_number: 'Số lượng người cho tặng',
  batch_use_number2: 'Lượng tiêu hao',
  batch_operation_status: 'Trạng thái thao tác',
  batch_ing_status: 'Đang trong quá trình tiến hành',
  batch_success: 'Thành công',
  batch_failed: 'Thất bại',
  batch_select: 'Mời lựa chọn',
  common_to: 'Đến',
  common_start_time: 'Ngày bắt đầu',
  common_end_time: 'Ngày kết thúc',
  batch_search_tips:
    'Dán tài khoản người dùng dán vào chỗ này dùng dấu phẩy để cách, 1 lần nhiều nhất có thể dẫn vào 50 người dùng',
  common_un_exist: 'Chưa đăng ký',
  common_invalid: 'Vô hiệu',
  batch_all_give: 'Số lượng tặng cho',
  batch_single_people: 'Cá nhân',
  batch_all: 'Số lượng',
  batch_name: 'Tên gọi',
  batch_added_credits: 'Số lượng tặng cho',
  batch_spent_credits: 'Số lượng tiêu phí',
  batch_account_status: 'Trạng thái tài khoản',
  batch_Added_total: 'Tổng tính tặng cho',
  batch_spent_total: 'Tổng tính tiêu phí',
  batch_Remaining: 'Thừa/dư lại',
  batch_Recipients: 'Người trao tặng',
  batch_Active: 'Đã kích hoạt',
  batch_search: 'Tìm kiếm',
  certificate_details: 'Chi tiết thông tin giấy chứng nhận',
  get_official_mock_certificate: 'Đạt giấy chứng nhận vượt qua kỳ thi mô phỏng chính thức',
  certificate_tips:
    'Thông tin chi tiết về chứng chỉ được lấy từ thông tin cá nhân của bạn, xin vui lòng xác nhận thông tin là chính xác:',
  country: 'Quốc tịch',
  select_country: 'Xin vui lòng chọn quốc tịch',
  email_to: 'Giấy chứng nhận sẽ được gửi qua email:',
  polyphonic: 'Chữ có nhiều âm đọc',
  click_tips: 'Nhấp vào số câu hỏi để xem câu trả lời của bạn',
  download_tips: 'Bạn có thể tải về giấy chứng nhận cho bài thi nào mà bạn đã vượt qua',
  cancel_delete_account: 'Xóa tài khoản',
  cancel_confirm: 'Xác nhận',
  user_apply_delete_account_title: 'Yêu cầu xoá tài khoản',
  user_apply_delete_account_confirm_tip: 'Xác nhận thông tin đăng nhập',
  user_apply_delete_account_alwaysTip:
    'Bạn đang yêu cầu xoá vĩnh viễn tài khoản HSK Mock và các dữ liêu có liên quan.',
  user_apply_delete_account_confirm_tip2:
    'Vui lòng xác nhận danh tính của bạn trước khi gửi yêu cầu',
  user_apply_delete_account_desc:
    '{email} của bạn dùng để đăng nhập  <a href="{mockLink}" target="_blank">HSK Mock</a> đồng thời cũng sử dụng đăng nhập <a href="{wohuiLink}" target="_blank">Wohui Mandarin</a>',
  user_apply_delete_account_desc2:
    'Sau khi xóa, bạn sẽ không thể tiếp tục sử dụng tài khoản để đăng nhập vào các ứng dụng trên.',
  user_apply_delete_account_wohui_title: 'Huỷ đăng ký Wohui',
  user_apply_delete_account_hsk_title: 'Số dư HSK Mock',
  user_apply_delete_account_next_tip:
    'Nhấp vào nút "Tiếp theo" để xác nhận rằng bạn đã đọc và đồng ý với những điều kiện trên.',
  user_apply_delete_account_next_title: 'Tiếp theo',
  user_apply_delete_account_confirm_tip11:
    'Trước tiên vui lòng huỷ đăng ký , sau đó quay lại để hoàn tất yêu cầu xoá tài khoản của bạn',
  cancel_delete_ok: 'Đồng ý',
  cancel_delete_request_send: 'Gửi yêu cầu',
  user_apply_delete_account_confirm_tip8:
    'Khi đăng ký của bạn hết hạn vào {date}, tài khoản của bạn sẽ bị xoá vĩnh viễn',
  user_apply_delete_account_confirm_tip4: 'Chúng tôi sẽ gửi email đến',
  user_apply_delete_account_confirm_tip5: 'Để xác nhận tài khoản của bạn đã bị xoá',
  user_apply_delete_account_confirm_tip6: 'Để hủy yêu cầu của bạn, vui lòng ấn "Huỷ"',
  user_apply_delete_data_always:
    'Bạn có muốn huỷ yêu cầu xoá tài khoản HSK Mock và dữ liệu cá nhân liên quan không?',
  cancel_delete_yes: 'Xác nhận',
  cancel_delete_no: 'Huỷ',
  user_cancel_delete_success:
    'Chúng tôi đã huỷ yêu cầu của bạn và sẽ không xoá tài khoản HSK Mock của bạn.',
  user_cancel_subscribe_again: 'Bạn có thể đăng ký lại',
  user_apply_delete_account_confirm_tip9: 'Hạn đăng ký của bạn hết hạn vào',
  user_apply_delete_account_confirm_tip10: 'Vui lòng chọn thời điểm bạn muốn xóa tài khoản',
  user_apply_delete_account_ok_btn_title: 'Đăng kí hết hạn',
  user_apply_delete_account_now_btn_title: 'Đăng xuất ngay lập tức',
  cancel_out_subscription_abnormal: 'Thông tin đăng ký người dùng bất thường',
  user_apply_delete_account_confirm_tip3:
    'Bạn có một gói đăng ký được Apple tự động tính phí, vui lòng huỷ đăng ký Apple trước khi gia hạn.',
  user_apply_delete_stripe_tip:
    'Đăng ký thông qua Stripe sẽ được tự động trừ vào thẻ tín dụng/thẻ ghi nợ của bạn. Vui lòng truy cập trang web của chúng tôi',
  user_apply_delete_account_balance: 'Số dư tài khoản của bạn là',
  user_apply_delete_account_balance_tip: 'Sau khi tài khoản bị xoá , số dư sẽ không được hoàn lại.',
  user_apply_delete_account_expire: 'Tài khoản của bạn sẽ xóa vĩnh viễn trong 3 ngày tới',
  my_class_name: 'Lớp học của tôi',
  my_class_search: 'Tìm kiếm lớp học',
  my_class_total: 'Tổng cộng',
  my_class_people: 'Người',
  my_class_ci: 'Lượt người',
  my_class_number: 'Số lượng người',
  my_class_ci_number: 'Số lần',
  my_class_tips: 'Vòng tròn bên trong: Tỷ lệ phân bổ HSK và YCT',
  my_class_tips1: 'Vòng tròn bên ngoài:Tỷ lệ phân bố điểm HSK và YCT',
  my_class_all_class: 'Tất cả các lớp học',
  follow_lesson: 'Xem các khoá học',
  real_paper: 'Thực hiện các bài thi thử trên đề thật',
  start_answer: 'Bắt đầu làm bài',
  edit_message_date: 'Ngày',
  edit_message_language: 'Ngôn ngữ',
  edit_message_zh: 'Tiếng Trung',
  edit_message_en: 'Tiêu đề',
  edit_message_title: 'Tiêu đề',
  edit_message_content: 'Nội dung tin nhắn',
  edit_message_show: 'Hiển thị trên',
  edit_message_save_success: 'Lưu thành công!',
  edit_message_create_success: 'Thêm thành công!',
  edit_message_edit1: 'Chỉnh sửa',
  edit_message_follow_notice: 'Xem thông báo',
  edit_message_textarea_tips:
    'Nếu bạn thêm liên kết (link), vui lòng thêm dấu cách sau liên kết để phân biệt',
  edit_message_notifications: 'Chỉnh sửa thông báo',
  edit_message_Send_time: 'Thời gian gửi',
  edit_message_edit_notification: 'Chỉnh sửa thông báo',
  edit_message_add: 'Thông báo mới',
  edit_message_from: 'Thời gian bắt đầu',
  edit_message_to: 'Thời gian kết thúc',
  edit_message_new_add: 'Thông báo mới',
  currency: 'Lựa chọn tiền tệ',
  pay_failed: 'Tải trang thất bại?',
  pay_un_finished: 'Thanh toán không thể hoàn tất',
  select_currency_tips: '如果您愿意，您可以从下面的下拉列表中选择不同的货币',
  change_currency_tips: '您可以随时在“我的帐户”下更改您的首选货币。',
  my_homework: 'Bài tập của tôi',
  my_homework_add: 'Giao bài tập',
  my_homework_all_classes: 'Toàn bộ lớp học',
  my_homework_paper: 'Tên bộ đề thi',
  my_homework_sent_to: 'Gửi đến',
  my_homework_sent_on: 'Thời gian gửi',
  my_homework_due_on: 'Thời hạn',
  my_homework_submitted_assignees: 'Số lượng người nộp/ Số lượng người gửi',
  my_homework_class_hint:
    'Dấu ngoặc đơn quanh tên lớp học có nghĩa là đề thi chỉ được giao cho một số học sinh trong lớp',
  my_homework_delay_hint:
    'Hiển thị xem người học có cho phép nộp bài tập sau thời hạn được chỉ định hay không',
  my_homework_add_send_assignment: 'Gửi bài tập',
  my_homework_add_new_assignment: 'Bài tập mới',
  my_homework_edit_assignment: 'Chỉnh sửa bài tập',
  my_homework_add_assignment: 'Thêm bài tập',
  my_homework_add_assignment_details: '1. Chi tiết bài tập',
  my_homework_add_issue_time: 'Thời gian gửi bài tập',
  my_homework_add_whether_submit: 'Có được phép nộp sau thời hạn hay không',
  my_homework_add_note: 'Ghi chú nội dung',
  my_homework_add_assignees: '2. Đối tượng gửi',
  my_homework_edit_add_assignees: '发送对象',
  my_homework_add_group: 'Nhóm',
  my_homework_add_immediate_release: 'Gửi ngay bây giờ',
  my_homework_add_time_release: 'Hẹn giờ gửi',
  my_homework_add_are: 'Có',
  my_homework_add_no: 'Không',
  my_homework_detail_back: 'Quay lại bài tập về nhà của tôi',
  my_homework_detail_sent_to: 'Gửi đến',
  my_homework_detail_leamers_in: 'Học sinh ở',
  my_homework_detail_on: 'Tại',
  my_homework_detail_to_complete_by: 'Gửi hoàn tất tại',
  my_homework_detail_add_assignee: 'Thêm đối tượng gửi',
  my_homework_detail_assignee: 'Đối tượng được gửi',
  my_homework_search_placeholder: 'Vui lòng nhập nội dung tìm kiếm',
  my_homework_stu_sent_by: 'Người gửi',
  my_homework_total_topic_count: 'Tổng {count} câu hỏi',
  my_homework_time_full: '{min} phút',
  my_homework_preview: 'Xem trước',
  cookie_consent_title: 'Sự đồng ý về Cookie',
  cookie_consent_desc1: 'Chúng tôi sử dụng cookie để phân tích việc sử dụng trang web nhằm cải thiện trải nghiệm của bạn.',
  cookie_consent_desc2: 'Bằng cách nhấp vào “Chấp nhận tất cả cookie”, bạn đồng ý cho phép lưu cookie trên thiết bị của mình để cải thiện khả năng điều hướng trang web và phân tích việc sử dụng trang web. Bạn có thể nhấp vào “Từ chối tất cả” để từ chối các cookie không thiết yếu.',
  cookie_consent_policy_link: 'Đọc Chính sách Cookie của chúng tôi.',
  cookie_consent_reject: 'Từ chối tất cả',
  cookie_consent_accept: 'Chấp nhận tất cả cookie',
  my_homework_select_date_time: 'Chọn ngày và thời gian',
  my_homework_delete_assignment_title: 'Xoá bài tập',
  my_homework_delete_assignment_tips:
    'Bạn có chắc chắn muốn xoá bài tập, thao tác này không thể hoàn tác sau khi xoá.',
  my_homework_assignment_add_fail: 'Tải lên thất bại!',
  my_homework_assignment_add_success: 'Tải lên thành công!',
  my_homework_assignment_edit_success: 'Chỉnh sửa thành công!',
  my_homework_assignment_edit_fail: 'Chỉnh sửa thất bại!',
  my_homework_assignment_delete_fail: 'Xoá thất bại!',
  my_homework_assignment_delete_success: 'Xoá thành công!',
  my_homework_assignment_due_on: 'Thời hạn',
  my_homework_assignment_product: 'Tên sản phẩm',
  my_homework_assignment_certificate: 'Giấy chứng nhận',
  my_homework_assignment_reset: '重置',
  reset_paper: 'Đặt lại bài thi',
  my_homework_assignment_reset_title: 'Cài đặt lại',
  my_homework_assignment_gifted: 'Số lượng quà tặng',
  my_homework_assignment_papers: 'Bài thi',
  my_homework_assignment_send_to: 'Bài tập được gửi đến',
  my_homework_assignment_close_tip: '当前作业发送还未保存，确认退出吗？',
  pay_callback_tips:
    'Nếu bạn đang ở Trung Quốc nhưng không phải công dân Trung Quốc, chúng tôi khuyên bạn nên sử dụng thẻ Visa hoặc Master .Chúng tôi đang nghiên cứu một số giải pháp hỗ trợ như Wechat, Alipay và Union Pay.',
  no_available_class: 'Chưa có lớp học để lựa chọn',
  payment_method: 'Phương thức thanh toán',
  wechat_pay: 'WeChat Pay',
  alipay_payment: 'Alipay',
  card_payment: 'Trả bằng thẻ',
  card_payment_description: 'Chỉ thẻ ngân hàng nước ngoài',
  payment_to_wohui: 'Thanh toán cho Công ty TNHH Wohui Technology (Thượng Hải)',
  order_submitted:
    'Đơn đặt hàng đã được gửi thành công, xin vui lòng thanh toán càng sớm càng tốt.',
  order_number: 'Mã đơn đặt hàng',
  code_expires: 'Màu <span style="color: #fc5a5a;font-size: 16px;font-weight: 500;">{time}</span>',
  use_weChat: 'Vui lòng sử dụng WeChat quét mã QR để thanh toán',
  code_expired: 'Mã QR hiện tại đã hết hạn',
  amount_payable: 'Số tiền phải trả',
  use_code: 'Dùng mã kích hoạt',
  tests: 'Bài kiểm tra',
  level_title: 'Bạn đang hướng tới cấp độ nào',
  // level_des:
  //   'Nếu bạn không chắc chắn, hãy làm <b style="color: #000;cursor: pointer;font-weight: 700;" class="clickable">bài kiểm tra trình độ miễn phí ></b>',
  level_HSK_text1:
    '<b>HSK</b> là viết tắt của "Hanyu Shuiping Kaoshi", có nghĩa là Kỳ thi kiểm tra trình độ Hán Ngữ.',
  level_HSK_text2: 'Đây là những bài kiểm tra trình độ Hán Ngữ phổ biến nhất thế giới.',
  level_YCT_text1: '<b>YCT</b> là viết tắt của "Youth Chinese Tests",',
  level_YCT_text2:
    'là một phiên bản khác của bài kiểm tra trình độ Hán Ngữ được điều chỉnh phù hợp cho những người học nhỏ tuổi.',
  level_BEGINNER: 'Sơ cấp',
  level_INTERMEDIATE: 'Trung cấp',
  level_ADVANCED: 'Cao cấp',
  level_dialog_title: 'Kiểm tra trình độ',
  level_dialog_content:
    'Bài kiểm tra trình độ miễn phí mất khoảng 15 phút và sẽ cho bạn thấy cấp độ HSK bạn đang hướng tới và mức gần đạt đến cấp độ đó trong từng kỹ năng (Nghe, Đọc, Viết và Nói).',
  level_dialog_login: 'Đăng nhập/ Đăng ký',
  level_dialog_start: 'Bắt đầu kiểm tra trình độ',
  about_us_first_paragraph:
    '<b>HSK Mock</b> là nền tảng chính thức duy nhất cho các bài kiểm tra thực hành HSK và YCT, các kỳ thi kiểm tra trình độ Hán Ngữ phổ biến nhất thế giới. Nền tảng này là sản phẩm của sự hợp tác giữa <b>Chinese Testing International</b> và <b>Wo Hui Mandarin</b>.',
  about_us_second_paragraph:
    '<b>Chinese Testing International</b> (CTI) là hội đồng thi HSK và YCT. Họ là một công ty TNHH có trụ sở tại Bắc Kinh nhằm thúc đẩy và hỗ trợ việc học, giảng dạy và kiểm tra Hán Ngữ như một ngoại ngữ trên toàn thế giới bằng cách cung cấp một loạt các dịch vụ cho cả cá nhân và tổ chức.',
  about_us_third_paragraph:
    '<b>Wo Hui Mandarin</b> (Wo Hui) cung cấp các nền tảng trực tuyến chính thức cho các khóa học HSK và YCT và các bài kiểm tra thực hành. Họ là một công ty TNHH có trụ sở chính tại Singapore, tận dụng công nghệ để đưa việc học vào tay học sinh và trao quyền cho giáo viên để hỗ trợ học sinh trên hành trình học tập cá nhân.',
  about_us_cti_text: 'Tìm hiểu thêm tại:',
  about_us_wohui_text: 'Hãy liên lạc nếu bạn muốn khám phá thêm:',
  listening_section: 'Kỹ năng nghe',
  reading_section: 'Kỹ năng đọc  hiểu',
  writing_section: 'Kỹ năng viết',
  review_answers: 'Xem lại câu trả lời',
  characters_long: 'Nếu bạn chưa có tài khoản, hãy đặt mật khẩu dài từ 6 đến 20 ký tự.',
  complete_profile: 'Hoàn thành hồ sơ của bạn',
  verify_email: 'Xác minh email của bạn',
  link_sent:
    'Cảm ơn bạn đã đăng ký. Vui lòng xác minh rằng chúng tôi có địa chỉ email chính xác cho bạn bằng cách nhấp vào liên kết chúng tôi đã gửi đến::',
  resend_link: 'Gửi lại liên kết >',
  restart: 'Khởi động lại',
  parental_consent: 'Sự đồng ý của phụ huynh',
  sent_parental:
    'Cảm ơn bạn đã đăng ký. Vui lòng xin phép sự đồng ý của phụ huynh hoặc người giám hộ của bạn bằng cách làm theo hướng dẫn chúng tôi đã gửi trong email tới::',
  thank_you: 'Cảm ơn!',
  or_return: 'Hoặc quay lại ứng dụng dành cho thiết bị di động',
  child_profile: 'Hồ sơ của con bạn',
  sign_up_privacy:
    'Tôi đã đọc và đồng ý với <a class="link" target="_blank" rel="noopener noreferrer" href="{url}">Điều khoản dịch vụ</a> và  <a class="link" target="_blank" rel="noopener noreferrer" href="{userUrl}">Chính sách bảo mật</a>.',
  give_consent: 'Tôi đồng ý',
  delete_child_details: 'Xóa thông tin chi tiết của con tôi',
  account_created: 'Tài khoản đã tạo',
  emailed_know:
    "Chúng tôi đã gửi email cho <span style='font-weight: 700'>{email}</span> để thông báo cho họ.",
  account_deleted: 'Tài khoản đã xoá',
  child_know_deleted: 'Vui lòng cho con bạn biết rằng thông tin chi tiết của chúng đã bị xóa.',
  request_email:
    'Tất cả các chi tiết (ngoại trừ địa chỉ email) có thể được cập nhật sau khi đăng nhập.',
  preferred_currency: 'Đơn vị tiền tệ ưu tiên',
  parent_guardian: 'Phụ huynh / Người giám hộ',
  class_name: 'Lớp học của tôi',
  tofficial_platform: 'Nền tảng thi HSK trên đề thật duy nhất được công nhận',
  proficiency_tests: 'để thực hành làm bài kiểm tra trình độ Hán Ngữ phổ biến nhất thế giới',
  get_started: 'Bắt đầu',
  platform_china: 'Chúng tôi cũng cung cấp nền tảng này cho các thí sinh ở Trung Quốc đại lục.',
  take_confidence: 'Tự tin thi HSK',
  practice_tests: 'Thực hành thi HSK và YCT',
  using_time:
    'Sử dụng các bài thi thật trong những năm gần đây do chính hội đồng thi cung cấp, cho phép bạn làm quen với định dạng của bài kiểm tra, trả lời các loại câu hỏi khác nhau và hoàn thành từng phần thi trong thời gian quy định.',
  instant_results: 'Nhận kết quả tức thì',
  each_test_question:
    'và xem lại từng câu hỏi trong bài kiểm tra. Các bài kiểm tra của bạn không chỉ được chấm điểm mà bạn còn có thể xem chính xác câu hỏi nào bạn đã làm đúng. Đối với những câu làm sai, bạn cũng có thể xem câu trả lời đúng để bạn biết những kỹ năng nào bản thân cần phải cải thiện.',
  track_progress: 'Theo dõi từng bước tiến trình của bạn',
  ready_next_test:
    'để bạn biết chính xác khi nào bản thân sẵn sàng làm bài kiểm tra thực tế tiếp theo và có thể yên tâm nhận được kết quả tốt nhất có thể. Phần Lịch sử của bạn cho bạn biết ngày và giờ bạn đã thực hiện mỗi bài kiểm tra thực hành và kết quả của bạn cho mỗi kỹ năng đã thay đổi như thế nào trong từng bài kiểm tra.',
  receive_official_certificates: 'Nhận Giấy chứng nhận chính thức',
  certificates_provide_evidence:
    'cho mỗi bài kiểm tra thực hành bạn đã vượt qua. Các Giấy chứng nhận này cung cấp bằng chứng cho thấy bạn đã đạt được một mức độ thông thạo Hán Ngữ nhất định.',
  ready_next_level: 'Sẵn sàng cho cấp độ tiếp theo',
  check_description:
    'Xem mô tả về cấp độ tiếp theo của bạn để biết được mục tiêu bản thân hướng tới. Làm quen với định dạng của bài kiểm tra để không bỡ ngỡ khi thi. Xem trước và xem lại từ vựng được quy định để bạn biết bản thân đã bao quát được mọi thứ có thể xuất hiện trong bài kiểm tra.',
  on_the_move: 'Chuyển sang trang khác?',
  download_mobile:
    'Tải xuống ứng dụng dành cho thiết bị di động để làm bài kiểm tra trên điện thoại của bạn',
  hsk_beginner_advanced:
    '<span style="font-weight: 700">HSK</span> là viết tắt của "Hanyu Shuiping Kaoshi", có nghĩa là Kỳ thi kiểm tra trình độ Hán Ngữ. Đây là những bài kiểm tra trình độ Hán Ngữ phổ biến nhất thế giới. Có 9 cấp độ, từ sơ cấp đến cao cấp.',
  more: 'Thêm >',
  ytc_beginner_advanced:
    '<span style="font-weight: 700">YCT</span>là viết tắt của "Youth Chinese Tests", là một phiên bản khác của bài kiểm tra trình độ Hán Ngữ được điều chỉnh phù hợp cho những người học nhỏ tuổi. Có 4 cấp độ, từ sơ cấp đến trung cấp.',
  coming_end: 'Ra mắt vào cuối năm 2023',
  candidates_proficiency_speaking: 'Bài kiếm tra này khảo sát năng lực nói tiếng Hán của thí sinh.',
  level_oral_tests:
    '<span style="font-weight: 700">HSKK</span> là viết tắt của "Hanyu Shuiping Kouyu Kaoshi", có nghĩa là Kỳ thi kiểm tra trình độ Khẩu ngữ tiếng Hán.',
  check_test_dates: 'Kiểm tra ngày thi',
  book_test: 'Đặt lịch kiểm tra',
  international_platform:
    'Nền tảng Trung Quốc của chúng tôi được lưu trữ ở Trung Quốc đại lục; nền tảng quốc tế của chúng tôi được lưu trữ tại Singapore. Hai nền tảng hoàn toàn tách biệt. Vui lòng chọn nền tảng phù hợp nhất với bạn.',
  mock_platform: 'Nền tảng thi thử chính thức',
  home_proficiency_tests: 'để thực hành làm bài kiểm tra trình độ Hán Ngữ phổ biến nhất thế giới',
  currency_type: 'Lựa chọn tiền tệ',
  Pick_your_level: 'Chọn cấp độ của bạn',
  About_this_level: 'Giới thiệu về cấp độ này',
  test_session: 'phần thi',
  Learning_resources: 'Tài nguyên học tập',
  Take_practice_test: 'kiểm tra thực hành',
  Compare_syllabuses: 'So sánh giáo trình',
  table_shows_syllabuses:
    'Bảng này cho thấy trình độ HSK tương ứng của các khung chương trình khác nhau.',
  forrgin_lang: '0547 dành cho "học tiếng Hán như một ngoại ngữ"',
  Second_Language: '0523 dành cho "học tiếng Hán như một ngôn ngữ thứ hai"',
  Requirement_entry: 'Yêu cầu để vào',
  most_Chinese_universities: 'hầu hết các trường đại học Trung Quốc',
  Qing_Hua: 'Đại học Thanh Hoa',
  beijing_university: 'Đại học Bắc Kinh',
  working_towards: 'bạn đang hướng tới cấp độ',
  On: 'Vào ngày',
  Level_test: 'Kiểm tra trình độ',
  Retake_level_test: 'Làm lại bài kiểm tra trình độ',
  practice_test: 'Làm bài kiểm tra thực hành',
  Compare_syllabuses_a: 'So sánh với giáo trình khác',
  Not_sure: 'Không chắc chắn về trình độ của bạn?',
  free_level_test: 'Làm bài kiểm tra trình độ miễn phí',
  Examples: 'Ví dụ',
  product_code: 'Mã sản phẩm',
  enter_paper: 'Nhập mã kích hoạt của bạn để làm bài thi kiểm tra',
  no_code: 'Bạn không có mã kích hoạt? Mua mã kích hoạt ttừ đối tác của chúng tôi:',
  to_partner: 'Chuyển đến đối tác',
  code_here: 'Nhập mã kích hoạt vào đây',
  start_assigment: 'Bắt đầu',
  view_assigment: 'Xem',
  continue_assigment: 'Tiếp tục',
  choose_method: 'Vui lòng chọn cách',
  choose_new_method: 'Vui lòng chọn cách để mở bài thi mới.',
  browser_layer: '请在PC上使用Google Chrome浏览器或在移动设备上使用APP',
  partner_title1: 'Hy vọng bạn có thể trở thành',
  partner_title2: 'Đối tác của HSK Mock',
  company_name: 'Tên công ty',
  company_website: 'Trang web công ty',
  teachers_count: 'Số lượng giáo viên HSK bạn làm việc cùng',
  learners_count: 'Số lượng học sinh HSK bạn làm việc cùng',
  add_msg: 'Hãy để lại lời nhắn cho chúng tôi',
  contact_style: 'Tôi có thể liên lạc với bạn bằng cách nào?',
  send: 'Nhấn Gửi',
  partner_forms_desc:
    'Là đối tác của chúng tôi, bạn sẽ là đầu mối liên hệ chính của các ứng viên, giáo viên, trường học và trường đại học ở quốc gia hoặc khu vực của bạn.<br><br>Trang dashboard  và API đối tác của chúng tôi sẽ cho phép bạn kinh doanh các đề thi HSK và YCT chính thức của chúng tôi một cách ngoại tuyến hoặc trên trang web của riêng bạn bằng đồng tiền tệ của đất nước bạn. Các đối tác của chúng tôi có thể thiết lập mối quan hệ tốt với các trung tâm khảo thí và trung tâm đào tạo HSK, họ hy vọng sẽ mở rộng hoạt động kinh doanh và tăng cường mức độ nhận diện cho thương hiệu.<br><br>Nếu bạn muốn trở thành đối tác của chúng tôi, vui lòng <span style="color: #faae56; text-decoration-line: underline; cursor: pointer">đăng nhập vào </span> HSK Mock bằng tài khoản cá nhân của bạn, sau đó cho chúng tôi biết một số thông tin cơ bản bên dưới, chúng tôi sẽ liên hệ với bạn và sắp xếp một cuộc gặp.',
  submit_success: 'Gửi thành công',
  help_students_for_testing: 'Bạn đang lo lắng vì giúp học sinh ôn luyện thi?',
  help_students_for_testing_desc:
    'Giáo viên có vai trò quan trọng trong việc giúp người học đạt được mục tiêu.<br>Chúng tôi sẽ trao quyền cho giáo viên, hỗ trợ việc học tập của mỗi một học sinh.',
  become_partner: 'Trở thành đối tác của chúng tôi',
  become_partner_desc:
    'Đối với các thí sinh, cách tốt nhất là có thể liên hệ với trung tâm khảo thí địa phương để hỏi về chi tiết bài kiểm tra bằng ngôn ngữ mẹ đẻ của họ và thanh toán bằng phương thức thanh toán phổ biến tại địa phương.',
  partnership: 'Tìm hiểu về việc hợp tác',
  students_forward: 'Giúp học sinh của bạn ngày càng tiến bộ',
  hsk_confidence: 'Tự tin dự thi HSK',
  try_it_out: 'Dùng thử miễn phí',
  walk_through: 'Làm quen với quy trình thi',
  teachers_page_desc1:
    'Các tính năng và chức năng của nền tảng có thể hỗ trợ cho việc dạy một thầy một trò hay dạy cả lớp. Giúp học sinh làm quen với hình thức của từng cấp độ, đồng thời xem trước cũng như ôn lại từ vựng.',
  assign_practice_papers: 'Hẹn ngày và giờ đến hạn nộp',
  teachers_page_desc2:
    'và gửi bài thi cho học sinh của bạn. Bạn có thể sử dụng đề thi thử như một bài kiểm tra chính thức nhằm giúp học sinh làm quen với các dạng câu hỏi của bài thi HSK, từ đó có thể hoàn thành từng phần thi trong thời gian quy định.',
  get_instant_results: 'Trả kết quả ngay',
  teachers_page_desc3:
    'Không cần giáo viên chấm điểm thủ công! Kiểm tra xem học sinh trong lớp đã hoàn thành các bài kiểm tra được giao hay chưa. Xem điểm mỗi bài kiểm tra của học sinh.',
  review_their_answers: 'Xem lại câu trả lời của học sinh',
  teachers_page_desc4:
    'Bạn có thể xem chi tiết bài thi của học sinh theo từng lớp, từng kỹ năng, từng phần và thậm chí theo từng câu hỏi. Bằng việc xem lại câu trả lời của học sinh, bạn có thể xây dựng kế hoạch giảng dạy cho học sinh một cách chính xác và đưa ra góp ý cho học sinh.',
  track_prog: 'Theo dõi sự tiến bộ của học sinh',
  teachers_page_desc5:
    'Lập ghi chép đầy đủ và chi tiết với từng học sinh, thể hiện sự thay đổi về điểm số của từng kỹ năng trong mỗi kỳ thi, để bạn có thể nắm rõ hơn về thời gian học sinh sẵn sàng cho lần thi tiếp theo và có thể nâng cao sự tự tin của học sinh trong học tập…',
  students_next_level: 'Đưa học sinh học lên cấp độ cao hơn',
  teachers_page_desc6:
    'Nền tảng trong cùng hệ thống của chúng tôi có tài liệu khóa học HSK và YCT cũng như tất cả các công cụ và tài nguyên bạn cần để dạy và hỗ trợ từng học sinh của bạn trên hành trình học tập cá nhân hướng tới mục tiêu chinh phục kỳ thi.',
  teaching_resources: 'Tài nguyên giảng dạy',
  for_teachers: 'Dành cho giáo viên',
  teachers_desc1:
    'Vui lòng sử dụng tài khoản cá nhân của bạn <span style="color: #faae56; text-decoration-line: underline; cursor: pointer">đăng nhập vào</span> nền tảng thi thử HSK Mock.',
  teachers_desc2:
    'Vui lòng điền thông tin bên dưới, chúng tôi sẽ thiết lập dùng thử miễn phí cho trường của bạn.',
  school_name: 'Tên trường',
  school_web: 'Trang web của trường',
  num_of_hsk_teachers: 'Số lượng giáo viên HSK',
  num_of_hsk_learners: 'Số lượng học sinh HSK',
  hsk_submit_reading: 'Đọc hiểu',
  pay_tip:
    'Nếu bạn muốn sử dụng Alipay hoặc Wechat để thanh toán cho các đề thi thử, vui lòng sử dụng trang web dịch vụ tại Trung Quốc của chúng tôi hskmock.cn',
  use_pc_or_app:
    'Để bắt đầu, vui lòng chuyển sang máy tính xách tay/ để bàn hoặc tải xuống ứng dụng di động của chúng tôi.',
  download_certificate: 'Tải chứng nhận',
  create_certificate: 'Tạo chứng chỉ',
  certificate_is_downloaded: 'Giấy chứng nhận đã tải xuống',
  pay_discount_title: 'Bạn muốn mua bao nhiêu phiên thử nghiệm {level}?',
  total: 'Tổng cộng',
  pay: 'Thanh toán',
  price_desc:
    'Bạn chỉ cần chi trả cho chi phí đề thi. Nếu bạn mua nhiều đề thi cùng một lúc, bạn có thể nhận giá mức chiết khấu cho mỗi một đề thi.',
  the_level: 'Cấp độ',
  discounted_price: 'Giá',
  price_contact_us:
    'Chúng tôi cũng cung cấp dịch vụ mua số lượng lớn cho các trường học và tổ chức. Vui lòng <span style="color: #faae56; text-decoration-line: underline; cursor: pointer">liên hệ</span> với chúng tôi để thảo luận về nhu cầu cụ thể của bạn.',
  get_a_discount: 'Nhận được chiết khấu',
  finished_pay_discount_title: 'Đây là mã kích hoạt đề thi cấp độ {level_name}',
  btn_goto_papers: 'Đi đến đề thi {level_name}',
  test_count: 'Bài kiểm tra {test_num}',
  unit_price: 'Bài kiểm tra {price}',
  buy_code_tip:
    'Chúng tôi đã gửi mã kích hoạt đề thi qua email của bạn. Bây  giờ bạn chỉ cần chọn đề thi {level_name} bạn muốn làm và nhập mã để mở khoá.',
  discount_codes_left_tip:
    'Sau bài kiểm tra này, bạn sẽ có<span style="color:#62C1A5;font-size:16px;font-weight:500;">{count}Mã còn lại</span>cho cấp độ này',
  manage_class: 'Quản lý lớp học',
  to_manage_class:
    'Hệ thống quản lý lớp học sẽ được mở ra trong một tab mới. Khi bạn đã hoàn thành, hay quay lại tab này và làm mới trang.',
  code_used: 'Đã sử dụng',
  code_can_be_used: 'Không sử dụng',
  no_test: 'Số lượng',
  history_purchase_quantity: 'Số lượng',
  hsk_listen_part_title: 'Phần thi kỹ năng nghe',
  hsk_read_part_title: 'Phần thi kỹ năng đọc hiểu',
  hsk_write_part_title: 'Phần thi kỹ năng viết',
  Description: 'Mô tả',
  Test_format: 'Hình thức kiểm tra',
  Vocabulary: 'Từ vựng',
  sso_login_signup: 'Đăng nhập / đăng ký',
  sso_email_address: 'Địa chỉ email',
  sso_password: 'Mật khẩu',
  sso_characters_long: 'Nếu bạn chưa có tài khoản, hãy đặt mật khẩu dài từ 6 đến 20 ký tự.',
  sso_forget_pw: 'Quên mật khẩu',
  sso_agree_policy:
    'Tôi đã đọc và đồng ý với <u class="strong"><a href="{url}" target="_blank"> Điều khoản dịch vụ</a></u> và <u class="strong"><a href="{url}" target="_blank">Chính sách bảo mật</a></u>',
  sso_continue: 'Tiếp tục',
  sso_please_check: 'Mời đọc và đồng ý với <<Thoả thuận người dùng>> và <<Chính sách bảo mật>>',
  sso_invalid_email_address: 'Địa chỉ hộp thư điện tử phi pháp',
  sso_invalid_password: 'Định dạng mật khẩu không hợp lệ',
  sso_loading: 'Trong quá trình tải',
  sso_mock_platform: 'Nền tảng thi thử chính thức',
  sso_home_proficiency_tests:
    'để thực hành làm bài kiểm tra trình độ Hán Ngữ phổ biến nhất thế giới',
  sso_guardian_consent_error: 'Thao tác thất bại',
  sso_forget_pw_success: 'Thiết lập lại hộp thư mật mã gửi đi thành công',
  sso_forget_pw_error: 'Thiết lập lại hộp thư mật mã gửi đi thất bại',
  sso_log_in_error: 'Đăng nhập thất bại',
  sso_download_app_mobile:
    'Để có trải nghiệm tốt hơn khi sử dụng HSK Mock, xin vui lòng truy cập hskmock.com trên máy tính hoặc tải ứng dụng trên di dộng.',
  hsk_enter_listening: 'Phần thi Nghe',
  intro_msg_first: 'Bài thi này có {num} phần, bạn phải hoàn thành theo thứ tự.',
  intro_msg_second: 'Vui lòng hoàn thành từng phần của bài thi trong thời gian quy định.',
  intro_msg_third:
    'Nếu bạn đã hoàn thành phần thi này nhưng chưa đến hạn nộp, bạn có thể tiếp tục làm phần tiếp theo của bài thi nhưng không thể quay lại phần trước.',
  dialogue_listening:
    'Phần đầu tiên là phần thi Nghe. Vui lòng nhấp vào nút để phát đoạn ghi âm phía dưới và điều chỉnh âm thanh thiết bị của bạn nếu cần.',
  dialogue_listening_hskk:
    'Vui lòng nhấp vào nút để phát đoạn ghi âm phía dưới và điều chỉnh âm thanh thiết bị của bạn nếu cần.',
  dialogue_intro_msg_first:
    'Trong khi nhạc đang phát sẽ có phần giới thiệu về bài thi. Đồng thời, bạn có thể xem trước các câu hỏi ở phần thi Nghe.',
  dialogue_intro_msg_first_hskk:
    'Trong khi nhạc đang phát sẽ có phần giới thiệu về bài thi.',
  dialogue_intro_msg_second:
    'Để mô phỏng bài thi thật, bạn không thể tạm dừng, phát lại hoặc tua nhanh âm thanh của phần thi Nghe.',
  dialogue_intro_msg_second_hskk:
    'Để mô phỏng bài thi thật, bạn không thể tạm dừng.',
  dialogue_intro_msg_third:
    'Sau khi phần Nghe kết thúc, bạn sẽ có {duration} phút để xem lại câu trả lời của mình.',
  dialogue_intro_question: 'Bạn gặp vấn đề?',
  dialogue_preload_title: 'Tải tài liệu thi',
  dialogue_mock_paper_intro_title: 'Hướng dẫn thi',
  dialogue_mock_paper_intro_sentence1:
    'Bài thi này mất khoảng {minutes} phút. Hãy đảm bảo bạn có đủ thời gian và pin để hoàn thành bài thi trong một lần.',
  dialogue_mock_paper_intro_sentence2:
    'Bài thi này yêu cầu hỗ trợ mạng trong toàn bộ quá trình, vì vậy hãy đảm bảo bạn có kết nối mạng ổn định.',
  dialogue_mock_paper_intro_sentence3:
    'Nếu bạn đang sử dụng máy tính để bàn hoặc máy tính xách tay, vui lòng sử dụng trình duyệt web Chrome hoặc Safari phiên bản mới nhất.',
  dialogue_mock_paper_intro_sentence4:
    'Nếu bạn đang sử dụng máy tính bảng, vui lòng sử dụng ứng dụng di động của chúng tôi thay vì trình duyệt web. Nếu ứng dụng bị buộc đóng khi chạy nền, tiến độ làm bài thi sẽ không thể được lưu.',
  dialogue_mock_paper_intro_sentence5:
    'Trong quá trình thi, vui lòng không mở cửa sổ trình duyệt hoặc ứng dụng di động khác, chuyển đổi ngôn ngữ hoặc cắm/rút điện các thiết bị khác (chẳng hạn như ổ flash USB, tai nghe, v.v.).',
  diologue_mock_paper_quit: 'Bỏ',
  dialogue_mock_paper_intro_button: 'Tôi đã đọc và hiểu',
  mock_skip_introduction: 'Bỏ qua phần hướng dẫn',
  Listening: 'Kỹ năng nghe',
  Reading: 'Kỹ năng đọc hiểu',
  Writing: 'Kỹ năng viết',
  other_gender: 'Ẩn danh/ Khác',
  sso_no_binding_info_tip: 'Không thể cập nhật được thông tin chi tiết của bạn',
  sso_third_login_tip: 'Vyui lòng chọn website bạn muốn mở',
  sso_third_login_wohui: 'Đi đến WO Hui Madarin',
  sso_third_login_mock: 'Đi đến HSK Mock',
  dialogue_preload_intro_first: 'Audio bài nghe đang được tải xuống',
  dialogue_preload_intro_second:
    'Sau khi quá trình tải xuống hoàn tất, âm thanh sẽ phát tự động để bắt đầu bài thi',
  dialogue_preload_intro_third: 'Chúc may mắn!',
  mock_paper_preview: 'Xem trước bài thi',
  vocab_type: 'Phần nói',
  deadline_passed: 'Quá hạn ',
  personal_info_display_name_as: 'Tên hiển thị chứng chỉ',
  code_pratice_text: 'Làm bài kiểm tra thử  <span style="font-weight: 600;color: #0C0C0C"> {level_name} </span>  bằng  <span style="font-weight: 600;color: #0C0C0C"> {paper_name} </span> .',
  code_input_text: 'Nhập mã Code:',
  use_code_limit: 'Mỗi Code chỉ được sử dụng một lần',
  code_select_text: 'Hoặc đổi mã code:',
  pay_discounts_desc1: 'Luyền đề những đề thi thật trước đây, có thể giúp bạn',
  pay_discounts_desc2:
    'Bạn đạt được thành tích cao nhất trong bài kiểm tra [{type}] [{level}] của bạn.',
  pay_discounts_desc3: 'Mua 1 tặng 1',
  pay_discounts_desc4:
    'Nếu bạn đã đăng kí thi  [{type} {level}]chính thức nên được hưởng ngay ưu đãi " mua 1 tặng 1" đề thi mô phỏng[{type} {level}] ',
  pay_discounts_desc5: 'Bạn muốn bao nhiêu bộ đề mô phỏng?',
  level_HSKK_text1: 'Bài thi nói HSK kiểm tra khả năng nói tiếng Trung của thí sinh. Bao gồm ba cấp độ: sơ cấp, trung cấp và cao cấp.',
  level_HSKK_text2: 'Bài thi nói sử dụng hình thức ghi âm',
  level_HSKK_text3: 'Thí sinh HSK3 phải vượt qua kỳ thi HSKK sơ cấp, thí sinh HSK cấp 4 phải vượt qua kỳ thi HSKK trung cấp và thí sinh HSK cấp 5 và 6 phải vượt qua kỳ thi HSKK cao cấp.',
  test_download_desc: 'Bài thi thử cấp độ này đang được chuẩn bị. Trong lúc chờ đợi, vui lòng tải xuống:',
  speaking: 'Khẩu ngữ',
  Traduction: 'Phiên dịch',
  my_homework_none_homework: 'Cấp độ này tạm thời chưa hỗ trợ thi thử, vui lòng chờ trong thời gian tới.',
  my_class_none_test: 'Cấp độ này tạm thời chưa hỗ trợ làm bài thi thử online, vui lòng chờ trong thời gian tới.',
  hsk_audio_error: 'Kết nối  mạng hiện tại của bạn không ổn định, audio bài nghe tải xuống thất bại. Vui lòng thử lại',
  mock_join_campus_text1: 'Bạn có chấp nhận lời mời tham gia cộng đồng dạy, học và thi này không?',
  mock_join_campus_text2: 'Sau khi tham gia cộng đồng, giáo viên có thể giao đề thi cho bạn trên HSKMock.com hoặc giao bài tập trên app.wohuimandarin.com',
  sso_join_campus_text4: 'Giáo viên có thể xem đáp án của bạn, để có thể đưa ra nhận xét',
  join: 'Tham gia',
  free_practice_title: 'Miễn phí luyện tập',
  choose_free_practice: 'Chọn 1 phương pháp luyện tập',
  word_flashcards: 'Thẻ thông tin từ ngữ / thẻ từ vựng (Flash card)',
  word_practice: 'Luyện tập từ ngữ',
  analyse_text: 'Phân tích văn bản',
  flashcards_title: 'Thẻ thông tin / thẻ từ vựng (Flash card)',
  practice_exercises_title: 'Bài tập luyện tập',
  analyse_title: 'Phân tích',
  practice_result_title: 'Kết quả luyện tập',
  generate_flashcards: 'Tạo thành 1 nhóm thẻ thông tin / thẻ từ vựng',
  generate_practice: 'Tạo thành 1 nhóm bài luyện tập',
  random_select: 'Chọn ngẫu nhiên',
  manual_select: 'Chọn thủ công',
  max_words: '{number} từ ngữ nhiều nhất',
  already_choose: 'Đã chọn: {total} cái',
  free_practice_words_quantifier: 'Cái',
  // 产品确认错误提示
  free_practice_unchoose_question: 'please select the question type, and cannot select all of them consecutively',
  free_practice_unchoose_practice: 'Hãy chọn 1 loại luyện tập',
  none_mark_words_hint: 'Từ ngữ bạn chưa đánh dấu ở cấp độ hiện tại',
  excceed_max_count: 'Được chọn nhiều nhất {total} từ, đã đạt tới giới hạn',
  free_practice_sound: 'Âm thanh',
  free_practice_question: 'Vấn đề (Đề bài)',
  free_practice_choose_exercise: 'Chọn dạng bài luyện tập',
  free_practice_exercise_select: 'Chọn mục cá nhân/ chọn 1 mục',
  free_practice_exercise_Pairs: 'Ghép đôi',
  free_practice_exercise_TF: 'Chọn đúng/ sai',
  launch: 'Khởi động',
  free_practice_check_text: 'Bạn làm đúng chưa?',
  free_practice_timer_pause: 'Tạm dừng ghi giờ / tạm dừng ghi thời gian',
  free_practice_timer_pause_desc: 'Nếu kiểm tra đến chưa thao tác, sẽ tự động tạm dừng đếm giờ',
  free_practice_seconds: '{number} giây, số giây',
  resume: 'Bắt đầu lại',
  flashcard_completed: 'Hoàn thành thẻ từ vựng',
  practice_completed: 'Hoàn thành luyện tập',
  practice_spent_minutes: 'Tổng thời gian: {duration} phút',
  practice_result_summary: 'Tổng kết kết quả',
  practice_result_progress_txt: 'Bạn đạt được',
  practice_wrong: 'Sai',
  practice_skip: 'Nhảy qua / bỏ qua',
  practice_done: 'Hoàn thành',
  analyse_desc_1: 'Phân tích từ vựng đã chọn trong văn bản',
  analyse_desc_2: 'Dán hoặc nhập văn bản tiếng trung ( Nhiều nhất không vượt qua{maxCount}ký tự)',
  analyse_input_placeholder: 'Nhập văn bản tiếng Trung',
  free_practice_need_word: 'Từ trong bảng biểu chọn từ vựng hoặc chọn tạo từ vựng ngẫu nhiên',
  free_practice_exercise_select_title: 'Chọn đáp án đúng',
  free_practice_exercise_pairs_title: 'Chọn liên kết phù hợp',
  free_practice_exercise_meaning_title: 'Nên dịch thành',
  free_practice_exercise_sound_title: 'Nên đọc thành',
  free_practice_exercise_characters_title: 'Nên viết thành',
  free_practice_show_correct_answers: 'Hiện thị đáp án đúng',
  free_practice_show_my_answers: 'Hiện thị đáp án của tôi',
  free_practice_check: 'Kiểm tra',
  //hsk_practice_num1
  free_practice_correct: 'Đúng',
  //vocabulary
  free_practice_characters: 'Chữ Hán',
     hsk_introduce_objective_questions: 'Câu hỏi khách quan',
  hsk_introduce_subjective_questions: 'Câu hỏi chủ quan',
  hsk_input_type_here: 'Vui lòng nhập vào đây',
  hsk_translation_part_title: 'Dịch phần thứ{count}',
  hsk_speaking_part_title: 'Khẩu ngữ phần thứ{count}',
  subjective_reading_placeholder: 'Dựa theo văn bản trên, trả lời câu hỏi...',
  hsk_write_by_artical: 'Dựa vào tài liệu (gợi ý) trên viết đoạn văn...',
  hsk_translation_by_artical: 'Dựa vào tại liệu (gợi ý) trên để phiên dịch...',
  hsk_trasnlation_choose_language: 'Tiếp theo là phần phiên dịch, hãy chọn loại ngôn ngữ',
  choose_speaker: 'Chọn loa / loa phát thanh',
  choose_microphone: 'Chọn micro',
  hsk_is_recording: 'Đang ghi âm',
  dialogue_speaking: 'Phần cuối cùng là phần khẩu ngữ. Hãy đảm bảo loa và micro của bạn hoạt động bình thường',
  start_recording: 'Nhấn để bắt đầu ghi âm',
  hsk_write_count: 'Chữ số',
  error_access_media: 'Đã xảy ra lỗi khi thiết bị truy cập phương tiện truyền thông',
  setSinkId_not_supported: 'Trình duyệt của bạn không hỗ trợ {setSinkId}',
  error_switch_device: 'Đã xảy ra lỗi khi chuyển đổi thiết bị',
  translation_section: 'Phần phiên dịch',
  speaking_section: 'Phần khẩu ngữ',
  failed_upload_record: 'Tải âm thanh ghi âm không thành công, vui lòng nhấp vào để tải lên lại.',
  hsk_enter_next_segment_write_high: 'Xác nhận gửi bài viết? Sau khi gửi, phần viết sẽ kết thúc và không thể quay lại để sửa đổi.',
  hsk_enter_next_segment_translate_tip: 'Bạn có câu{count}dịch chưa được trả lời,',
  hsk_enter_next_segment_translate: 'Xác nhận gửi bài dịch? Sau khi gửi, phần dịch sẽ kết thúc và không thể quay lại để sửa đổi.',
  hsk_enter_next_segment_speaking_tip: 'Bạn có câu{count}khẩu ngữ chưa được trả lời,',
  Speaking: 'Khẩu ngữ',
  Translating: 'Phiên dịch',

  mock_tests: 'Bài Thi Thử',
  more_menu: 'Tìm hiểu thêm',
  support: 'Trợ giúp',
  blog_and_faq: 'Blog & Câu hỏi thường gặp',
  for_institutions: 'Dành cho Trường học & Tổ chức Giáo dục',
  tofficial_platform_new: 'Nền tảng thi thử HSK chính thức',
  proficiency_tests_new: 'Tập hợp đề thi thật, chấm điểm chuyên nghiệp, củng cố từ vựng và luyện tập thông minh — hỗ trợ ôn thi hiệu quả.',
  start_practicing: 'Bắt đầu luyện tập',
  get_ready: 'Ôn thi HSK, bắt đầu từ bây giờ!',
  real_hsk_exam_content: 'Đề thi thật',
  real_hsk_exam_desc: 'Luyện tập với đề thi thật để ôn thi hiệu quả và tự tin bước vào kỳ thi.',
  official_level_scoring: 'Chấm điểm chuyên nghiệp',
  official_level_scoring_desc: 'Chấm điểm theo tiêu chuẩn chính thức của HSK, kết quả đáng tin cậy.',
  vocabulary_boost: 'Củng cố từ vựng',
  vocabulary_boost_desc: 'Sử dụng thẻ từ vựng miễn phí và công cụ luyện tập thông minh để ghi nhớ từ vựng dễ dàng!',
  get_hsk_ready: 'Bắt đầu ôn thi',
  how_it_works: 'Hướng dẫn sử dụng',
  choose_your_level: 'Chọn cấp độ',
  choose_your_level_desc: 'Chọn cấp độ thi phù hợp với bạn — từ HSK cấp 1 đến HSK cấp 9.',
  practise_and_learn: 'Học tập & Đánh giá',
  practise_and_learn_desc: 'Bắt đầu từ luyện từ vựng miễn phí! Nâng cấp tài khoản để mở khóa đề thi mô phỏng chính thức HSK và dịch vụ chấm điểm thông minh.',
  track_your_progress: 'Theo dõi tiến độ học tập',
  track_your_progress_desc: 'Sau mỗi lần làm bài, xem điểm từng phần, theo dõi tiến độ của bạn, xác định rõ hướng cải thiện, lên kế hoạch ôn tập hiệu quả.',
  get_started_new: 'Bắt đầu',
  real_results_from_real_learners: 'Phản hồi thật, Kết quả thật',
  start_learning: 'Bắt đầu học ngay',
  on_the_move_new: 'Tải ứng dụng HSK Mock, ',
  download_mobile_new: 'ôn thi HSK mọi lúc mọi nơi.',
  got_questions: 'Có câu hỏi? Chúng tôi có câu trả lời',
  faq: 'Câu hỏi thường gặp',
  faq_desc: 'Thắc mắc về ôn thi HSK và nền tảng HSK Mock.',
  faq_btn: 'Xem câu hỏi thường gặp',
  blog: 'Blog',
  blog_desc: 'Truy cập blog của chúng tôi để biết mẹo ôn thi HSK hữu ích.',
  blog_btn: 'Xem blog',
  contact: 'Liên hệ với chúng tôi',
  contact_desc: ' Cần hỗ trợ riêng? Có bất kỳ câu hỏi nào, hãy liên hệ với đội ngũ chăm sóc khách hàng của chúng tôi.',
  contact_btn: 'Liên hệ',
  footer: 'HSK Mock là nền tảng thi thử chính thức HSK — tổng hợp đề thi thật, chấm điểm chuyên nghiệp, củng cố từ vựng, luyện tập thông minh — hỗ trợ ôn thi hiệu quả.',
  choose_your_hsk_level: 'Chọn cấp độ HSK của bạn',
  choose_your_hsk_level_desc: 'Sử dụng đề thi mô phỏng chính thức và công cụ thông minh để ôn luyện cho HSK, HSK Khẩu ngữ và YCT.',
  hsk_levels: 'HSK',
  hsk_speaking: 'HSK Khẩu ngữ',
  yct: 'YCT',
  // hsk3.0
  hsk_levels_tri: 'New HSK',
  hsk_speaking_tri: 'New HSK Khẩu ngữ',
  level_des: 'Không chắc mình ở cấp nào? <b style="color: #000;cursor: pointer;font-weight: 700;" class="clickable">Nhấn vào đây để làm bài kiểm tra trình độ miễn phí ></b>',
  about_us_new: 'Giới thiệu',

  back_to_home: 'Quay lại trang chủ',
  about_us_desc:
    '<b>HSK Mock</b> là nền tảng thi thử trực tuyến chính thức cho kỳ thi <b>HSK</b>, <b>HSK Khẩu ngữ và</b> <b>YCT</b>. Mô phỏng sát thực tế, giúp người học ôn luyện hiệu quả, đánh giá chính xác, nâng cao toàn diện.',
  who_we_are: 'Chúng tôi là ai?',
  who_we_are_desc:
    'HSK Mock được phát triển bởi CTI (Chinese Testing International) và Wo Hui Mandarin, với mục tiêu cung cấp công cụ luyện thi và học tập đáng tin cậy cho người học tiếng Trung toàn cầu.',
  why_choose_hsk_mock: 'Vì sao nên chọn HSK Mock?',
  about_us_carousel_1: 'Kho đề thi mô phỏng chính thức',
  about_us_carousel_1_content:
    'Tuân thủ nghiêm ngặt cấu trúc đề thi thật của HSK, HSK Khẩu ngữ và YCT.',
  about_us_carousel_2: 'Hệ thống chấm điểm chuẩn xác',
  about_us_carousel_2_content:
    'Dựa trên tiêu chí giống như kỳ thi thật, đánh giá năng lực thực tế.',
  about_us_carousel_3: 'Công cụ học tập hiệu quả',
  about_us_carousel_3_content:
    'Bao gồm luyện từ vựng theo cấp độ, cải thiện toàn diện kỹ năng nghe, nói, đọc, viết.',
  about_us_carousel_4: 'Hỗ trợ đa nền tảng và thiết bị ',
  about_us_carousel_4_content: 'Sử dụng dễ dàng trên máy tính và điện thoại, học mọi lúc mọi nơi.',
  about_us_carousel_5: 'Sự lựa chọn của người học toàn cầu',
  about_us_carousel_5_content: 'Đã hỗ trợ hàng ngàn người học tiếng Trung trên khắp thế giới đạt được mục tiêu học tập.',
  institutional_title: 'Đánh giá năng lực tiếng Trung dành cho các tổ chức giáo dục',
  institutional_desc: 'Nền tảng thi thử chính thức HSK Mock cung cung cấp các bài đánh giá năng lực tiếng Trung trực tuyến theo đúng hình thức của kỳ thi HSK và YCT chính thức, hỗ trợ các trường học, đại học và các tổ chức giáo dục khác nhau trong việc đánh giá trình độ tiếng Trung của ngườii học và theo dõii liên tục tiến độ học tập.',
  institutional_btn: 'Xem giải pháp dành cho trường học/tổ chức',
  institutional_schools_title: 'Trường học và tổ chức giáo dục',
  institutional_schools_desc: 'Sử dụng đề thi HSK các năm để giúp học sinh ôn tập một cách có hệ thống cho kỳ thi HSK và YCT.',
  institutional_corp_title: 'Doanh nghiệp và đội ngũ nhân sự',
  institutional_corp_desc: 'Sử dụng để đánh giá năng lực tiếng Trung trong các dự án tuyển dụng, cử đi công tác nước ngoài hoặc đào tạo, giúp doanh nghiệp hiểu và quản lý năng lực ngôn ngữ của nhân viên một cách hiệu quả hơn.',

  real_hsk_exam_content_new: 'Chọn cấp độ HSK của bạn',
  real_hsk_exam_desc_new: 'Hoàn thành bài kiểm tra trình độ ngắn để nhận được cấp độ HSK được đề xuất.',
  official_level_scoring_new: 'Tham gia kỳ thi thử HSK chính thức',
  vocabulary_boost_new: 'Củng cố từ vựng của bạn',
  vocabulary_boost_desc_new: 'Chúng tôi cung cấp thẻ từ vựng miễn phí và công cụ luyện tập thông minh.',

  confidence_card0_detail_desc: 'Hoàn thành bài kiểm tra trình độ ngắn để nhận được cấp độ HSK được đề xuất.',
  confidence_card0_detail_btn: 'Kiểm tra trình độ miễn phí',
  confidence_choose_level: 'Chọn cấp độ',
  confidence_card1_detail_btn: 'Tiếp tục',
  confidence_choose_method: 'Chọn 1 phương pháp luyện tập',

  // ======== newhsk1-6 新版成绩报告页（词条来源：hsk_mock_web0819.xlsx）========
  // key 顺序与分组注释同 zh.js，便于逐条对照
  // -------- 区块标题 --------
  nr_section_overview: 'Tổng quan điểm số',
  nr_section_overview_aside: 'Thống kê theo cấu trúc đề thi',
  nr_section_answer: 'Chi tiết trả lời',
  nr_section_answer_aside: 'Màu xanh là đúng; màu đỏ là sai',
  nr_section_analysis: 'Phân tích kết quả',
  nr_section_analysis_desc: 'Xem bạn mất điểm chủ yếu ở đâu và phần thi nào bạn làm tốt hơn.',
  nr_section_diagnosis: 'Chẩn đoán học tập',
  nr_section_next: 'Gợi ý học tập tiếp theo',
  nr_section_next_aside:
    'Được tạo dựa trên chủ đề, nhiệm vụ ngôn ngữ, từ/chữ và mức độ nắm vững kiến thức',

  // -------- 头部 --------
  nr_head_title: 'Báo cáo điểm {name}',
  nr_head_result_title: 'Kết quả bài thi',
  nr_head_unmarked_wait: 'Bài thi vẫn đang được chấm. Vui lòng chờ.',
  nr_head_no_report:
    'Hiện chưa có câu trả lời hợp lệ cho bài thi này nên chưa thể phân tích mức độ nắm vững kiến thức và kết quả học tập của bạn. Hãy hoàn thành một số câu hỏi rồi xem lại phân tích điểm.',
  nr_head_unmarked_default:
    'Phần Viết chưa được tính vào tổng điểm và sẽ do giám khảo chuyên môn chấm. Khi chấm xong, tổng điểm sẽ được cập nhật và chúng tôi sẽ thông báo cho bạn qua email.',
  nr_head_loading: 'Đang tải đánh giá bài thi. Vui lòng chờ...',
  nr_head_loading_timeout: 'Chưa thể tạo đánh giá. Vui lòng thử lại sau.',
  nr_head_cert_hint_fail: 'Chưa đạt. Có thể tải xuống sau khi bạn đạt.',
  nr_price: '{currency}{amount}',

  // -------- 成绩概览 --------
  nr_overview_rate: 'Điểm: {n}%',

  // -------- 答题详情 --------
  nr_answer_accuracy: 'Độ chính xác: {n}%',
  nr_answer_more: 'Xem tất cả chi tiết trả lời ({n})',

  // -------- 个人成绩分析 --------
  nr_analysis_overall: 'Đánh giá tổng thể',
  nr_analysis_overall_pass:
    'Tổng điểm bài thi này của bạn là 【{score}】, 【đạt tiêu chuẩn đỗ HSK cấp {level}】. Bạn làm khá tốt ở 【{best}】, trong khi 【{worst}】 là phần cần cải thiện nhiều nhất hiện tại. Nên ưu tiên cải thiện 【{worst}】 đồng thời duy trì các điểm mạnh.',
  nr_analysis_overall_fail:
    'Tổng điểm bài thi này của bạn là 【{score}】, 【chưa đạt tiêu chuẩn đỗ HSK cấp {level}】. Bạn làm khá tốt ở 【{best}】, trong khi 【{worst}】 là phần cần cải thiện nhiều nhất hiện tại. Nên ưu tiên cải thiện 【{worst}】 đồng thời duy trì các điểm mạnh.',
  nr_analysis_overall_zero:
    'Tổng điểm bài thi này của bạn là 【0】, 【chưa đạt tiêu chuẩn đỗ HSK cấp {level}】. Hiện tất cả các phần đều cần cải thiện đáng kể. Nên ôn lại kiến thức cơ bản trước, sau đó chuyển dần sang luyện tập có mục tiêu.',
  nr_analysis_overall_full:
    'Tổng điểm bài thi này của bạn là 【{score}】, 【đạt tiêu chuẩn đỗ HSK cấp {level}】. Bạn làm tốt ở tất cả các phần và hiện chưa có phần nào cần ưu tiên cải thiện. Hãy tiếp tục duy trì tiến độ học tập hiện tại.',
  nr_analysis_overall_pass_nolevel:
    'Tổng điểm bài thi này của bạn là 【{score}】, 【đạt】 tiêu chuẩn đỗ. Bạn làm khá tốt ở 【{best}】, trong khi 【{worst}】 là phần cần cải thiện nhiều nhất hiện tại. Nên ưu tiên cải thiện 【{worst}】 đồng thời duy trì các điểm mạnh.',
  nr_analysis_overall_fail_nolevel:
    'Tổng điểm bài thi này của bạn là 【{score}】, 【chưa đạt】 tiêu chuẩn đỗ. Bạn làm khá tốt ở 【{best}】, trong khi 【{worst}】 là phần cần cải thiện nhiều nhất hiện tại. Nên ưu tiên cải thiện 【{worst}】 đồng thời duy trì các điểm mạnh.',
  nr_analysis_loss_title: 'Phần lớn {n} điểm bị mất đến từ',
  nr_analysis_loss_title_plain: 'Điểm bị mất chủ yếu ở',
  nr_analysis_score: '{n} điểm',
  nr_analysis_percent: 'Chiếm {n}% số điểm bị mất',
  nr_subject_listen: 'Nghe',
  nr_subject_read: 'Đọc',
  nr_subject_write: 'Viết',
  nr_subject_translation: 'Dịch',
  nr_subject_speaking: 'Nói',
  nr_part_ordinal_1: 'Phần 1',
  nr_part_ordinal_2: 'Phần 2',
  nr_part_ordinal_3: 'Phần 3',
  nr_part_ordinal_4: 'Phần 4',
  nr_part_ordinal_5: 'Phần 5',
  nr_analysis_row_name: '{subject}{part}',
  nr_analysis_strength: 'Phần mạnh hơn',
  nr_analysis_strength_tag: 'Điểm mạnh',
  nr_analysis_weakness: 'Phần ảnh hưởng nhiều nhất đến điểm số',
  nr_analysis_weakness_tag: 'Ưu tiên',

  // -------- 学习诊断 --------
  nr_diag_summary_title: 'Tổng quan kết quả học tập',
  nr_diag_summary_tag_good: '{name}: Kết quả tốt',
  nr_diag_summary_tag_weak: '{name}: Cần cải thiện',
  nr_diag_summary_tag_words: '{name}: Nên ưu tiên củng cố',
  nr_diag_topics_title: 'Mức độ nắm vững chủ đề',
  nr_diag_topics_aside: 'Phân nhóm theo mức độ thể hiện và độ chính xác',
  nr_diag_topics_more: 'Xem thêm chủ đề ({n})',
  // 语法点掌握：按听力 / 阅读 / 写作分项，一个分项一张卡
  nr_diag_grammars_title: 'Mức độ nắm vững ngữ pháp',
  nr_diag_grammars_aside:
    'Phân tích kết quả làm câu hỏi ngữ pháp trong phần Nghe và Đọc, cũng như cách sử dụng ngữ pháp trong phần Viết.',
  nr_diag_grammar_summary_label: 'Tổng kết kết quả lần này',
  nr_diag_col_grammar: 'Điểm ngữ pháp',
  nr_diag_grammars_more: 'Xem thêm điểm ngữ pháp ({n})',
  nr_diag_tasks_title: 'Mức độ nắm vững nhiệm vụ ngôn ngữ',
  nr_diag_tasks_aside: 'Dựa trên kết quả các nhiệm vụ giao tiếp trong bài thi này',
  nr_diag_tasks_more: 'Xem thêm nhiệm vụ ({n})',
  nr_diag_col_task: 'Nhiệm vụ ngôn ngữ',
  nr_diag_col_count: 'Số câu hỏi',
  nr_diag_col_accuracy: 'Độ chính xác',
  nr_diag_col_verdict: 'Kết quả',
  nr_diag_words_title: 'Từ và chữ chưa nắm vững',
  nr_diag_words_total: 'Tổng cộng {n} từ/chữ',
  nr_diag_word_wrong_count: 'Câu sai liên quan: {n}',
  nr_diag_word_tag: 'Chưa nắm vững',
  nr_diag_words_more: 'Xem thêm từ/chữ ({n})',
  nr_diag_stats_title: 'Thống kê từ & chữ',
  nr_diag_stat_involved: 'Từ/chữ xuất hiện',
  nr_diag_stat_unstable: 'Chưa nắm vững',
  nr_diag_stat_accuracy: 'Độ chính xác từ/chữ',
  nr_diag_stat_involved_note: 'Bài thi này có {n} từ/chữ',
  nr_diag_stat_unstable_note: 'Có {n} từ/chữ gây mất điểm đáng kể trong bài thi này',
  nr_diag_stat_accuracy_note: 'Tính dựa trên các từ/chữ xuất hiện trong bài thi này',
  nr_diag_stats_footnote:
    'Các số liệu trên chỉ dựa trên những từ và chữ xuất hiện trong bài thi này, không phản ánh mức độ nắm vững toàn bộ từ và chữ của cấp độ này.',
  nr_diag_question_count: '{n} câu',
  nr_diag_question_correct: '{n} câu đúng',
  nr_diag_question_total: 'Tổng {n} câu',

  // -------- 付费提示条 --------
  nr_banner_free_title: 'Báo cáo chẩn đoán học tập miễn phí trong thời gian giới hạn',
  nr_banner_free_desc:
    'Hiện bạn có thể xem miễn phí toàn bộ phân tích điểm, chẩn đoán học tập và gợi ý học tiếp theo.',
  nr_banner_owned_title: 'Đã mở khóa chẩn đoán học tập đầy đủ',
  nr_banner_owned_desc: 'Xem toàn bộ phân tích điểm, chẩn đoán học tập và gợi ý học tiếp theo.',
  nr_banner_paywall_title: 'Chẩn đoán học tập đầy đủ là tính năng trả phí',
  nr_banner_paywall_desc:
    'Xem miễn phí kết quả bài thi và chi tiết trả lời. Mở khóa để xem phân tích đầy đủ và gợi ý học tập.',

  // -------- 解锁卡 --------
  nr_unlock_tag: 'Báo cáo đầy đủ đang khóa',
  nr_unlock_title: 'Mở khóa phân tích điểm & chẩn đoán học tập đầy đủ',
  nr_unlock_desc:
    'Xem chi tiết nơi bạn mất điểm, mức độ nắm vững chủ đề, nhiệm vụ ngôn ngữ, từ/chữ và kiến thức, cùng gợi ý học tập tiếp theo.',
  nr_unlock_btn: 'Mở khóa báo cáo đầy đủ với {price}',
  nr_unlock_btn_plain: 'Mở khóa báo cáo đầy đủ',
  nr_unlock_footnote: 'Mua để xem báo cáo đầy đủ của bài thi này.',

  // -------- 通用 --------
  nr_common_retry: 'Thử lại',
  nr_common_collapse: 'Thu gọn',

  // -------- 模块名 --------
  nr_seg_listen: 'Nghe',
  nr_seg_read: 'Đọc',
  nr_seg_write: 'Viết',
  nr_seg_translation: 'Dịch',
  nr_seg_speaking: 'Nói',
  nr_part_name: 'Phần {n}',
  nr_seg_part: '{seg} · {part}',

  // -------- 题型名 --------
  nr_qtype_new_hsk1_listen_1: 'Nghe: Chọn hình',
  nr_qtype_new_hsk1_listen_2: 'Nghe: Chọn văn bản',
  nr_qtype_new_hsk1_listen_3: 'Nghe: Ghép hình',
  nr_qtype_new_hsk1_listen_4: 'Nghe hiểu',
  nr_qtype_new_hsk1_read_1: 'Ghép câu với hình',
  nr_qtype_new_hsk1_read_2: 'Ghép thông tin',
  nr_qtype_new_hsk1_read_3: 'Chọn từ điền vào chỗ trống',
  nr_qtype_new_hsk1_read_4: 'Đọc hiểu',
  nr_qtype_new_hsk2_listen_1: 'Nghe: Chọn hình',
  nr_qtype_new_hsk2_listen_2: 'Nghe: Ghép hình',
  nr_qtype_new_hsk2_listen_3: 'Nghe hiểu',
  nr_qtype_new_hsk2_read_1: 'Ghép câu với hình',
  nr_qtype_new_hsk2_read_2: 'Chọn từ điền vào chỗ trống',
  nr_qtype_new_hsk2_read_3: 'Ghép thông tin',
  nr_qtype_new_hsk2_read_4: 'Đọc hiểu',
  nr_qtype_new_hsk2_write_1: 'Chọn bộ phận chữ Hán',
  nr_qtype_new_hsk2_write_2: 'Viết chữ Hán theo pinyin',
  nr_qtype_new_hsk3_listen_1: 'Nghe: Ghép hình',
  nr_qtype_new_hsk3_listen_2: 'Nghe hiểu',
  nr_qtype_new_hsk3_listen_3: 'Nghe hiểu',
  nr_qtype_new_hsk3_read_1: 'Ghép thông tin',
  nr_qtype_new_hsk3_read_2: 'Chọn từ điền vào chỗ trống',
  nr_qtype_new_hsk3_read_3: 'Đọc hiểu',
  nr_qtype_new_hsk3_write_1: 'Viết chữ Hán theo pinyin',
  nr_qtype_new_hsk3_write_2: 'Đặt câu theo hình và từ cho sẵn',
  nr_qtype_new_hsk4_listen_1: 'Nghe hiểu',
  nr_qtype_new_hsk4_listen_2: 'Nghe hiểu',
  nr_qtype_new_hsk4_read_1: 'Chọn từ điền vào chỗ trống',
  nr_qtype_new_hsk4_read_2: 'Đọc hiểu',
  nr_qtype_new_hsk4_read_3: 'Chọn câu điền vào chỗ trống',
  nr_qtype_new_hsk4_write_1: 'Đặt câu theo hình và từ cho sẵn',
  nr_qtype_new_hsk4_write_2: 'Viết đoạn văn ngắn',
  nr_qtype_new_hsk5_listen_1: 'Nghe hiểu',
  nr_qtype_new_hsk5_listen_2: 'Nghe hiểu',
  nr_qtype_new_hsk5_read_1: 'Chọn từ điền vào chỗ trống',
  nr_qtype_new_hsk5_read_2: 'Sắp xếp đoạn văn',
  nr_qtype_new_hsk5_read_3: 'Đọc hiểu',
  nr_qtype_new_hsk5_write_1: 'Viết theo chuỗi tranh',
  nr_qtype_new_hsk5_write_2: 'Viết theo chủ đề',
  nr_qtype_new_hsk6_listen_1: 'Chọn câu phù hợp với nội dung nghe',
  nr_qtype_new_hsk6_listen_2: 'Nghe hiểu',
  nr_qtype_new_hsk6_listen_3: 'Nghe hiểu',
  nr_qtype_new_hsk6_read_1: 'Chọn từ điền vào chỗ trống',
  nr_qtype_new_hsk6_read_2: 'Chọn câu điền vào chỗ trống',
  nr_qtype_new_hsk6_read_3: 'Đọc hiểu',
  nr_qtype_new_hsk6_write_1: 'Viết văn bản thực dụng',
  nr_qtype_new_hsk6_write_2: 'Viết theo chủ đề',

  // -------- 下一步学习建议 --------
  nr_next_topic_text:
    'Bài thi này có {total} câu về “{name}”. Bạn trả lời sai {wrong} câu, độ chính xác là {rate}%. Nên tăng cường học nội dung liên quan đến chủ đề này.',
  nr_next_task_text:
    'Bài thi này có {total} câu về “{name}”. Bạn trả lời sai {wrong} câu, độ chính xác là {rate}%. Nên tiếp tục luyện tập với các câu hỏi liên quan.',
  nr_next_words_text:
    'Bạn bị mất điểm ở các từ/chữ như “{words}” trong bài thi này. Hãy ưu tiên ôn lại nghĩa, cách dùng và ngữ cảnh sử dụng.',
  nr_next_grammar_text:
    'Trong bài thi này, có tổng cộng {total} câu liên quan đến “{name}”; bạn trả lời sai {wrong} câu, với độ chính xác là {rate}%. Nên củng cố cách dùng cơ bản của “{content}” và luyện tập với các câu ví dụ liên quan.',
  nr_next_words_separator: ', ',

  // -------- 错误提示 --------
  nr_err_load_failed: 'Không tải được báo cáo điểm. Vui lòng thử lại sau.',
  nr_err_scene_unsupported: 'Báo cáo điểm mới hiện chưa hỗ trợ loại bài thi này.',
  nr_err_level_mismatch: 'Báo cáo điểm này không khả dụng cho loại bài thi hiện tại.',
  nr_err_no_credit: 'Bạn đã dùng hết số lượt thi thử hiện có.',
  nr_err_retake_network: 'Lỗi mạng. Vui lòng thử lại.',
  nr_err_retake_failed: 'Hiện chưa thể bắt đầu bài thi. Vui lòng thử lại sau.',
  nr_err_question_not_found: 'Dữ liệu câu hỏi có vấn đề. Vui lòng tải lại đề thi.',
  nr_err_view_question_failed: 'Hiện chưa thể xem câu hỏi này. Vui lòng thử lại sau.',
  nr_err_common: 'Thao tác không thành công. Vui lòng thử lại sau.',
  nr_err_pay_failed: 'Không thể bắt đầu thanh toán. Vui lòng thử lại sau.',
  nr_err_pay_closed: 'Đơn hàng đã đóng. Vui lòng thực hiện thanh toán mới.',
  nr_err_pay_timeout:
    'Đang xác nhận thanh toán. Nếu bạn đã thanh toán xong, hãy làm mới trang để kiểm tra kết quả.',
  // 以下为首页改版（2026-09 原型）新增词条，暂用英文占位，待翻译后替换
  home_v2_hero_kicker: 'Official Online HSK Mock Test Platform',
  home_v2_hero_title_1: 'Take an Official',
  home_v2_hero_title_2: 'HSK Mock Test Online',
  home_v2_hero_desc: 'Test your Chinese proficiency with real HSK exam questions, real test timing and HSK aligned scoring.',
  home_v2_hero_image_alt: 'HSK Mock platform displayed on a desktop computer in a warm modern home office',
  home_v2_choose_your_exam: 'Choose Your Exam',
  home_v2_proof_cti_title: 'Developed with Chinese Testing International',
  home_v2_proof_cti_desc: 'The organisation behind the HSK exam.',
  home_v2_proof_learners_title: 'Learners worldwide',
  home_v2_proof_learners_desc: 'Preparing for HSK with HSK Mock.',
  home_v2_proof_authentic_title: 'Authentic past exam content',
  home_v2_proof_authentic_desc: 'Real question types, structure and scoring.',
  home_v2_ai_badge: 'New',
  home_v2_ai_title: 'See Where You Can Improve Before Test Day',
  home_v2_ai_desc: 'The AI Score Report turns your New HSK mock test into clear insights you can use for your next study session.',
  home_v2_ai_slide1_a: 'Score',
  home_v2_ai_slide1_b: 'Overview',
  home_v2_ai_slide2_a: 'Topic, Grammar,',
  home_v2_ai_slide2_b: 'Language Task Mastery',
  home_v2_ai_slide3_a: 'Words, Characters',
  home_v2_ai_slide3_b: 'to Review',
  home_v2_ai_slide4_a: 'Next Study',
  home_v2_ai_slide4_b: 'Recommendations',
  home_v2_ai_cta: 'Explore New HSK Mock Tests',
  home_v2_ai_note: 'Only available with New HSK mock tests.',
  home_v2_testimonials_title: 'What Learners Achieved with HSK Mock',
  home_v2_testimonials_desc: 'Real preparation experiences and measurable exam results.',
  home_v2_experience_title: 'Practise the HSK Online',
  home_v2_exp1_a: 'Real Test',
  home_v2_exp1_b: 'Interface',
  home_v2_exp1_desc: 'Take a full mock test with real HSK structure, timing and authentic past exam content.',
  home_v2_exp1_alt: 'HSK Mock real test interface',
  home_v2_exp2_a: 'HSK Aligned',
  home_v2_exp2_b: 'Scoring',
  home_v2_exp2_desc: 'See your result clearly after the test, with scoring aligned to HSK standards.',
  home_v2_exp2_alt: 'HSK Mock scoring results',
  home_v2_exp3_a: 'Improve Your',
  home_v2_exp3_b: 'Vocabulary',
  home_v2_exp3_desc: 'Review the words and characters that need more attention before your next attempt.',
  home_v2_exp3_alt: 'HSK Mock vocabulary review',
  home_v2_b2b_title: 'HSK Mock for Schools and Institutions',
  home_v2_b2b_lead: 'Give your learners HSK and YCT mock tests online. Review completion and scores in one place, and see where more preparation is needed.',
  home_v2_b2b_point1: 'Choose tests by exam and level',
  home_v2_b2b_point2: 'See completion and scores',
  home_v2_b2b_point3: 'Spot where learners need more practice',
  home_v2_b2b_cta: 'Talk to Our Education Team',
  home_v2_b2b_image_alt: 'Students taking HSK Mock tests online in a classroom',
  home_v2_app_label: 'HSK Mock mobile app',
  home_v2_app_title: 'Continue Your Preparation Wherever You Study',
  home_v2_app_desc: 'Switch between desktop and mobile with the same account to take mock tests and review your results wherever you study.',
  home_v2_app_store_pre: 'Download on the',
  home_v2_app_store_aria: 'Download HSK Mock on the App Store',
  home_v2_google_play_pre: 'Get it on',
  home_v2_google_play_aria: 'Get HSK Mock on Google Play',
  home_v2_app_learner_alt: 'Learner preparing for HSK on a laptop',
  home_v2_app_phone_alt: 'HSK Mock mobile app shown on a phone',
  home_v2_help_title: 'Need Help?',
  home_v2_help_faq: 'FAQ',
  home_v2_help_faq_desc: 'Find answers to the most common questions about HSK preparation and our platform.',
  home_v2_help_faq_link: 'Browse FAQs',
  home_v2_help_contact: 'Contact',
  home_v2_help_contact_desc: 'Need personalised help? Get in touch with our support team for any questions or concerns.',
  home_v2_help_contact_link: 'Contact Us',
  home_v2_help_bubble: 'Need help?',
  home_v2_help_mascot_alt: 'HSK Mock panda mascot',
  // 以下为等级选择页改版（2026-09 原型）新增词条，暂用英文占位，待翻译后替换
  choose_v2_intro: 'Select the exam you are preparing for, then choose your level.',
  choose_v2_back: 'Back to homepage',
  choose_v2_select_exam: 'Select Exam',
  choose_v2_choose_level: 'Choose Level',
  choose_v2_level_help: 'Not sure which level to choose?',
  choose_v2_level_help_link: 'Try the free level test',
  choose_v2_fact_questions: '{n} questions',
  choose_v2_fact_minutes: '{n} minutes',
  choose_v2_fact_minutes_about: 'About {n} minutes',
  choose_v2_fact_full_speaking: 'Complete speaking test',
  choose_v2_result_immediate: 'Results available immediately',
  choose_v2_result_48h: 'Results within 48 hours',
  choose_v2_result_before_purchase: 'Result timing shown before purchase',
  // 以下为等级详情页改版（2026-09 原型）新增词条，暂用英文占位，待翻译后替换
  product_v2_back: 'Change exam or level',
  product_v2_badge_aria: 'Selected exam',
  product_v2_tabs_aria: 'Level navigation',
  product_v2_tab_tests: 'Tests',
  product_v2_tab_about: 'About',
  product_v2_tab_vocabulary: 'Vocabulary',
  product_v2_tab_free: 'Free Practice',
  product_v2_tab_resources: 'Resources',
  product_v2_tests_heading: '{level} Mock Tests',
  product_v2_single_price_aria: 'Price for one HSK Mock test',
  product_v2_single_test: 'Single test',
  product_v2_price_before_payment: 'Price shown before payment',
  product_v2_tests_guidance: 'Choose an HSK Mock test.',
  product_v2_status_ready: 'Ready',
  product_v2_status_progress: 'In progress',
  product_v2_status_complete: 'Completed',
  product_v2_use_code: 'Use a code',
  product_v2_bundle_heading: 'Save with Multi-Test Packs',
  product_v2_pack_tests: 'test | tests',
  product_v2_pack_saving: 'Save {n}',
  product_v2_pack_continue: 'Continue · {price}',
  product_v2_go_title_1: 'A little Chinese.',
  product_v2_go_title_2: 'Every day.',
  product_v2_go_desc_1: 'Learn at your level with HSK 1–3 courses.',
  product_v2_go_desc_2: 'Get official HSK 1 or 2 certification in the app.',
  product_v2_go_apple_aria: 'Download HSK GO on the App Store (opens in a new tab)',
  product_v2_go_google_aria: 'Get HSK GO on Google Play (opens in a new tab)',
  product_v2_go_site_aria: 'Visit the HSK GO website (opens in a new tab)',
  product_v2_auth_purchase_title: 'Continue to buy this test',
  product_v2_auth_purchase_intro: 'Your HSK Mock test will be added to the account you choose after payment.',
  product_v2_auth_purchase_login: 'Log in, review the order and continue to payment.',
  product_v2_auth_purchase_signup: 'Create and verify an account before payment.',
  product_v2_auth_redeem_title: 'Sign in to use your test code',
  product_v2_auth_redeem_intro: 'Your code will add this HSK Mock test to the account you choose.',
  product_v2_auth_redeem_login: 'Log in and add the test to your account.',
  product_v2_auth_redeem_signup: 'Create and verify an account, then add the test.',
  product_v2_auth_have_account: 'Already have an account?',
  product_v2_auth_new: 'New to HSK Mock?',
  product_v2_auth_login: 'Log In',
  product_v2_auth_signup: 'Create Account',
}
